// import React from 'react';
import { render } from '@testing-library/react';
import React, { useState, useEffect, PureComponent, useRef, useMemo, useCallback, Fragment } from 'react';
// import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { NavLink } from 'react-router-dom';
import {
  BarChart,
  Bar,
  Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  LineChart,
  Line,
  Legend,
  ReferenceLine,
  ResponsiveContainer,
  Label,
} from 'recharts';
import { PieChart, Pie, Sector, } from "recharts";
import "./EpicfinanceTrends.css";
import { isEqual } from "lodash";
import * as ReactBootstrap from 'react-bootstrap';
import Accordion from 'react-bootstrap/Accordion';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import $ from 'jquery'

import config from '../config';
import Sidebar from '../SideMenu';

// import { Accordion } from "react-bootstrap";
// var Accordion = require('react-bootstrap').Accordion;
// var Panel = require('react-bootstrap').Panel;
// var responseData;
const colors = ["#0c2340", "#0095c8", "#b7c9d3", "#7030a0"]
const RADIAN = Math.PI / 180;
const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, value, index }) => {

  const radius = innerRadius + (outerRadius - innerRadius) * 0.2;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  if (value > 1) {
    return (

      <text x={x} y={y} fill="white" className="text-size-a" textAnchor={x > cx ? 'start' : 'end'} >

        {`${(value).toFixed(2)}%`}
      </text>
    )
  };

};
const renderCustomizedLabelFixed = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, value, index, name }) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.4;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);
  const labelarray = ['#ffffff', '#ffffff', '#000000', '#ffffff', '#ffffff', '#ffffff', '#ffffff', '#000000'];
  if (value > 5) {
    const colors = labelarray[index]
    return (

      <text x={x} y={y} fill={colors} className="text-size-a-wealth" textAnchor={x > cx ? 'start' : 'end'} >

        {`${(value).toFixed(2)}%`}
      </text>
    )
  };
};
const renderCustomized12LabelFixed = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, value, index, name }) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.4;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);
  const labelarray = ['#ffffff', '#ffffff', '#000000', '#ffffff', '#ffffff', '#ffffff', '#ffffff', '#000000'];
  if (value > 5) {
    const colors = labelarray[index]
    return (

      <text x={x} y={y} fill={colors} className="text-size-a-wealth" textAnchor={x > cx ? 'start' : 'end'} >

        {`${(value).toFixed(1)}%`}
      </text>
    )
  };
};
// const graphData = []
// const graphDataVAR = []
// const graphDataSectorPer =[]
// const cummulatovePerfData =[]
// const cummulatovePerfDatadummy =[]

// const twelvemonPerfDiscreteAPI = []
// const top3contriarray =[]
// const bot3contriarray = []
const Fundinfoarray = []
const ShareClassarray = []

let bot3contriDummy = []


// const usePrevious = value => {
//   const ref = useRef();
//   useEffect(() => {
//     ref.current = value;
//   });
//   return ref.current;
// };


const data = [

  {
    name: 'Page A',
    uv: 4000,
    pv: 2400,
    // amt: 2400,
  },
  {
    name: 'Page B',
    uv: -3000,
    pv: 1398,
    // amt: 2210,
  },
  {
    name: 'Page C',
    uv: -2000,
    pv: -9800,
    // amt: 2290,
  },
  {
    name: 'Page D',
    uv: 2780,
    pv: 3908,
    // amt: 2000,
  },
  {
    name: 'Page E',
    uv: -1890,
    pv: 4800,
    // amt: 2181,
  },
  {
    name: 'Page F',
    uv: 2390,
    pv: -3800,
    // amt: 2500,
  },
  {
    name: 'Page G',
    uv: 3490,
    pv: 4300,
    // amt: 2100,
  },

];

const VARdata = [
  {
    name: 'Page A',
    uv: 0.34,
    //   pv: 2400,
    //   amt: 2400,
  },
  {
    name: 'Page B',
    uv: 0.11,
    //   pv: 1398,
    //   amt: 2210,
  },
  {
    name: 'Page C',
    uv: -0.04,
    //   pv: -9800,
    //   amt: 2290,
  },
  {
    name: 'Page D',
    uv: 1.5,
    //   pv: 3908,
    //   amt: 2000, 
  },

];
const SECdata = [
  {
    name: 'Page A',
    uv: -1,
    //   pv: 2400,
    //   amt: 2400,
  },
  {
    name: 'Page B',
    uv: -0.52,
    //   pv: 1398,
    //   amt: 2210,
  },
  {
    name: 'Page C',
    uv: -0.60,
    //   pv: -9800,
    //   amt: 2290,
  },
  {
    name: 'Page D',
    uv: 1.29,
    //   pv: 3908,
    //   amt: 2000, 
  },

];

const Donutdata = [


  { name: "Group D", value: 3.1 },
  { name: "Group A", value: 71.9 },
  { name: "Group C", value: 16.4 },
  { name: "Group B", value: 8.6 },


];
const renderColorfulLegendText = (value, entry) => {
  const { color } = entry;
  if (entry.payload.value != undefined) {
    return <span className="legend-span">{value + ' ' + (entry.payload.payload.value).toFixed(2) + '%'}</span>;
  } else {
    return <span style={{ color: "#1a1549" }}>{value}</span>;
  }
};

const renderColor12fulLegendText = (value, entry) => {
  const { color } = entry;

  return <span className="legend-span">{value + ' ' + (entry.payload.value) + '%'}</span>;
};
// const DONUTCOLORS = [ "#b7c9d3","#7030a0","#00C49F", "#FFBB28", "#FF8042"];
const DONUTCOLORS10 = ["#1A1549", "#9DB1DB", "#E6EEF6", "#dcdcdc", "#666666", "#404040", "#262626", "#99103B", "#B85876", "#D296A9"];

const DONUTCOLORS7 = ["#1A1549", "#9DB1DB", "#E6EEF6", "#dcdcdc", "#666666", "#99103B", ": #B85876"];

const DONUTCOLORS5 = ['#1A1549', '#9DB1DB', '#D0DEF5', '#99103B', '#B85876', '#D296A9', '#dcdcdc', '#666666', '#404040', '#262626']
const DONUTCOLORS9 = ['#1A1549', '#9DB1DB', '#D0DEF5', '#99103B', '#B85876', '#D296A9', '#dcdcdc', '#666666', '#404040', '#262626']

const DONUTCOLORS = ["#1a2352", "#7030a0", "#0095c8", "#ffc000", "#ff9933", "#99103b", "blue", "green", "red", "yellow", "orange"];
const DONUTCOLORS8 = ['#1A1549', '#99103b']
const DONUTCOLORS6 = ['#1A1549', '#9DB1DB', '#D0DEF5', '#99103B', '#B85876', '#D296A9', '#dcdcdc', '#666666', '#404040', '#262626']

const EpicglobalEquity = () => {




  const [products, setProducts] = useState([]);
  const [productsVAR, setProductsVAR] = useState([]);
  const [productsSectorPer, setProductsSectorPer] = useState([]);
  const [SessionResponse, setSessionResponse] = useState([]);

  const [productscommulativePerformance, setproductscommulativePerformance] = useState([]);
  const [productscommulativePerformanceB, setproductscommulativePerformanceB] = useState([]);
  const [productscommulativePerformanceBEUR, setproductscommulativePerformanceBEUR] = useState([]);
  const [productscommulativePerformanceBUSD, setproductscommulativePerformanceBUSD] = useState([]);

  const [productscommulativePerformanceC, setproductscommulativePerformanceC] = useState([]);
  const [productscommulativePerformanceEUR, setproductscommulativePerformanceEUR] = useState([]);

  const [twelvemonPerfAGBP, settwelvemonPerfAGBP] = useState([]);
  const [twelvemonPerfBGBP, settwelvemonPerfBGBP] = useState([]);
  const [twelvemonPerfBEUR, settwelvemonPerfBEUR] = useState([]);
  const [twelvemonPerfBUSD, settwelvemonPerfBUSD] = useState([]);
  const [twelvemonPerfCGBP, settwelvemonPerfCGBP] = useState([]);
  const [twelvemonPerfDEUR, settwelvemonPerfDEUR] = useState([]);


  const [InceptionData, setInceptionData] = useState([]);







  // const [productscommulativePerformanceA, setproductscommulativePerformanceA] = useState([]);

  const [products12monthsPerformance, setproducts12monthsPerformance] = useState([]);
  const [productstop3contr, setproductstop3contr] = useState([]);
  const [productsbot3contr, setproductsbot3contr] = useState([]);
  const [productsCommentary, setproductsCommentary] = useState([]);
  const [productsFundinfo, setproductsFundinfo] = useState([]);
  const [CMSFundinfo, setCMSFundinfo] = useState([]);
  const [CMSshareinfo, setCMSshareinfo] = useState([]);
  const [productsShareClass, setproductsShareClass] = useState([]);
  const [productsMonthlyPerf, setproductsMonthlyPerf] = useState([]);

  const [productsMonthlyPerfB, setproductsMonthlyPerfB] = useState([]);
  const [productsMonthlyPerfC, setproductsMonthlyPerfC] = useState([]);

  const [productsMonthlyPerfBEUR, setproductsMonthlyPerfBEUR] = useState([]);

  const [RespPrtu, setRespPrtu] = useState([]);

  const [PRTU, setPRTU] = useState([]);


  const [portfolioStatus, setportfolioStatus] = useState(false);
  const [performanceStatus1, setperformanceStatus1] = useState(false);

  const [graphData, setgraphData] = useState([]);
  const [top10HoldingState, settop10HoldingState] = useState([]);
  const [marketCapState, setmarketCapState] = useState([]);
  const [sectorBreakdownSData, setsectorBreakdownSDataState] = useState([]);
  const [InceptionArrayState2, setInceptionArrayState2] = useState([]);
  const [sectorBreakdownState, setsectorBreakdownState] = useState([]);
  const [InceptionArrayState, setInceptionArrayState] = useState([]);





  const [graphDataVAR, setgraphDataVAR] = useState([]);
  const [graphDataSectorPer, setgraphDataSectorPer] = useState([]);
  const [cummulatovePerfData, setcummulatovePerfData] = useState([]);
  const [cummulatovePerfBData, setcummulatovePerfBData] = useState([]);
  const [CummulativeperfeBEURData, setCummulativeperfeBEURData] = useState([]);
  const [CummulativeperfeBUSDData, setCummulativeperfeBUSDData] = useState([]);

  const [CummulativeperfC, setCummulativeperfC] = useState([]);
  const [CummulativeperfDEUR, setCummulativeperfDEUR] = useState([]);



  const [TwelveMperfAGBPState, setTwelveMperfAGBPState] = useState([]);



  const [TwelveMperfBGBPState, setTwelveMperfBGBPState] = useState([]);
  const [TwelveMperfBEURState, setTwelveMperfBEURState] = useState([]);
  const [TwelveMperfBUSDState, setTwelveMperfBUSDState] = useState([]);

  const [TwelveMperfCGBPState, setTwelveMperfCGBPState] = useState([]);
  const [TwelveMperfDEURState, setTwelveMperfDEURState] = useState([]);





  const [twelvemonPerfDiscreteAPI, settwelvemonPerfDiscreteAPI] = useState([]);
  const [top3contriarray, settop3contriarray] = useState([]);
  const [bot3contriarray, setbot3contriarray] = useState([]);
  const [Fundinfoarray, setFundinfoarray] = useState([]);
  const [CMSFundinfoarray, setCMSFundinfoarray] = useState([]);
  const [CMSshareinfoarray, setCMSshareinfoarray] = useState([]);

  const [ShareClassarray, setShareClassarray] = useState([]);
  const [monthsArrayState, setmonthsArrayState] = useState([]);
  const [monthlyPerformance2DArrayState, setmonthlyPerformance2DArrayState] = useState([]);
  const [monthlyPerformanceB2DArrayState, setmonthlyPerformanceB2DArrayState] = useState([]);
  const [monthsBArrayState, setmonthsBArrayState] = useState([]);

  const [monthlyPerformanceC2DArrayState, setmonthlyPerformanceC2DArrayState] = useState([]);
  const [monthsCArrayState, setmonthsCArrayState] = useState([]);

  const [monthlyPerformanceD2DArrayState, setmonthlyPerformanceD2DArrayState] = useState([]);
  const [monthsDArrayState, setmonthsDArrayState] = useState([]);

  const [arrPRTUState, setarrPRTUState] = useState([]);
  const [PRTUDate, setPRTUDate] = useState([]);

  const [DailyDate, setDailyDate] = useState([]);
  const [StateSession, setStateSession] = useState([]);


  const [HeadingState, setHeadingState] = useState([]);
  const [ObjectiveState, setObjectiveState] = useState([]);
  const [TeamState, setTeamState] = useState([]);
  const [Summary, setSummary] = useState([]);


  const [Loading, setLoading] = useState(false);

  const [productRegional, setproductRegional] = useState([]);
  const [productstop10Holding, setproductstop10Holding] = useState([]);
  const [productsmarketCap, setproductsmarketCap] = useState([]);
  const [productSectorBreakdown, setproductSectorBreakdown] = useState([]);

  const [Literature, setLiterature] = useState([]);
  const [LiteratureDataState, setLiteratureDataState] = useState([]);
  const [LiteratureSummaryDataState, setLiteratureSummaryDataState] = useState([]);

  const [FundNameState, setFundNameState] = useState([]);
  const [KeyInveInfoState, setKeyInveInfoState] = useState([]);
  const [PressCoverageState, setPressCoverageState] = useState([]);
  const [ApplicationsState, setApplicationsState] = useState([]);
  const [ReportsState, setReportsState] = useState([]);
  const [offerDocumentState, setofferDocumentState] = useState([]);










  // const twelvemonPerfDiscreteAPI = []
  // const top3contriarray =[]
  // const bot3contriarray = []
  const [status, setstatus] = useState(false);

  // const [productstest, setproductstest] = useState([]);
  // const {current:a} = useRef(productscommulativePerformance)
  // const prevCountRef = useRef(productscommulativePerformance)
  // const ABC = ""
  // let XYZ = ""
  // const objjj = Object.assign({}, productsbot3contr);
  // const objee = Object.assign({}, objjj);

  // const prevArr = usePrevious(arr);



  useEffect(() => {

    fetchMyAPI()

  }, [])






  const portfolioButton = () => {

    const graphDataResponse = []
    const graphDataResponse1 = []
    const graphDataResponse344 = []
    const graphDataResponse2 = []

    const top10HoldingData = []
    const marketCapData = []
    const InceptionDataArray2 = []
    const sectorBreakdownData = []

    // const fundInfoData =[]

    var allKeys = ["name", "current month", "pevious month"];


    // for(let i=1 ; i< products.length ;i++){
    //   // typeof(products[i][j])

    //   let obj={};
    //   for(let j =0 ;j< products[i].length ;j++){

    //     if(!isNaN(products[i][j])){
    //     let val = products[i][j];
    //     // var numb= 212421434.533423131231;
    //     var rounded2 = Math.round((val + Number.EPSILON) * 100) / 100;

    //     console.log(rounded2);
    //     obj[allKeys[j]] = rounded2 ;

    //   }
    //     // var updatedVal =  parseFloat(val).toFixed(2);
    //     // console.log(updatedVal);
    //     else{
    //       obj[allKeys[j]] = products[i][j] ;
    //     }     

    //     }

    //     graphDataResponse.push(obj)
    //     // setTimeout()


    //     // console.log(graphData);
    //     // console.log("allKeys")


    // }

    var keysVAR = ["name", "value"]
    var length = productRegional.length

    for (let i = 1; i < length; i++) {
      // typeof(products[i][j])

      let obj = {};
      for (let j = 0; j < productRegional[i].length; j++) {
        // if(productRegional[i][j]>0){
        if (!isNaN(productRegional[i][j])) {
          let val = productRegional[i][j];

          // var numb= 212421434.533423131231;
          var rounded1 = Math.round((val + Number.EPSILON) * 100) / 100;
          rounded1 = parseFloat(rounded1).toFixed(2);
          if (rounded1 == 0.00) {
            rounded1 = 0;
          }
          obj[keysVAR[j]] = rounded1 * 100;

        }

        // var updatedVal =  parseFloat(val).toFixed(2);
        // console.log(updatedVal);
        else {

          obj[keysVAR[j]] = productRegional[i][j];
        }
        // }
      }
      if (obj.value !== 0) {
        graphDataResponse1.push(obj)

      }
      // console.log(graphData);
      // console.log("allKeys")

    }


 


    var keystop10Hold = ["no", "name", "value"]



    for (let i = 0; i < productstop10Holding.length; i++) {
      // typeof(products[i][j])

      let obj = {};
      for (let j = 0; j < productstop10Holding[i].length; j++) {

        if (!isNaN(productstop10Holding[i][j])) {
          let val = productstop10Holding[i][j] * 100;

          // var numb= 212421434.533423131231;
          var rounded = Math.round((val + Number.EPSILON) * 100) / 100;

          obj[keystop10Hold[j]] = rounded + '%';
         
        }

        // var updatedVal =  parseFloat(val).toFixed(2);
        // console.log(updatedVal);
        else {
          obj[keystop10Hold[j]] = productstop10Holding[i][j];
       
        }

      }
      top10HoldingData.push(obj)


    }


    var keysInceptionData21 = ["name", "value"]
    var length = productstop10Holding.length;
    let obj1 = {};
    let obj2 = {};
    let obj = {};
 
    obj1[keysInceptionData21[0]] = productstop10Holding[1][5];
    let val12 = productstop10Holding[1][6] * 100;
    var rounded112 = Math.round(Math.round((val12 + Number.EPSILON) * 100) / 100, 1);
    obj1[keysInceptionData21[1]] = rounded112;
    obj2[keysInceptionData21[0]] = productstop10Holding[2][5];
    let val123 = productstop10Holding[2][6] * 100;
    var rounded1123 = Math.round(Math.round((val123 + Number.EPSILON) * 100) / 100, 1);
    obj2[keysInceptionData21[1]] = rounded1123;
    obj = [obj1, obj2]
    let objlength = obj.length
    for (let i = 0; i < objlength; i++) {
      //console.log(obj[i].value);
      if (obj[i].value !== 0) {
        InceptionDataArray2.push(obj[i])
      }
    }






    // var keysMarketCap = ["name", "value"]
    //   var length = productsmarketCap.length-1;
    //  for(let i=1 ; i< length ;i++){
    //   // typeof(products[i][j])

    //   let obj={};
    //   // for(let j =0 ;j< productsmarketCap[i].length ;j++){
    //     for(let j =0 ;j< productsmarketCap[i].length ;j++){

    //     if(!isNaN(productsmarketCap[i][j])){
    //     let val = productsmarketCap[i][j]*100;

    //     // var numb= 212421434.533423131231;
    //     var rounded = Math.round((val + Number.EPSILON) * 100) / 100;

    
    //     obj[keysMarketCap[j]] = rounded ;

    //   }

    //     // var updatedVal =  parseFloat(val).toFixed(2);
    //     // console.log(updatedVal);
    //     else{
    //       obj[keysMarketCap[j]] = productsmarketCap[i][j] ;
    //     }     

    //     }
    //     if(obj.value !==0){

    //     // marketCapData.push(obj)

    //     }


    //     // console.log(graphDataSectorPer);
    //               // console.log("allKeys")

    // }

    var keysMarketCap = ["name", "value"]
    var length = productsmarketCap.length;
    for (let i = 1; i < length; i++) {
      let obj = {};
      for (let j = 0; j < productsmarketCap[i].length; j++) {

        if (!isNaN(productsmarketCap[i][j])) {

          let val = productsmarketCap[i][j] * 100;
          // var numb= 212421434.533423131231;
          var rounded = Math.round((val + Number.EPSILON) * 100) / 100;
   
          obj[keysMarketCap[j]] = rounded;

        }
        // var updatedVal =  parseFloat(val).toFixed(2);
        // console.log(updatedVal);
        else {
          obj[keysMarketCap[j]] = productsmarketCap[i][j];
        }

      }
      if (obj.value !== 0) {
        marketCapData.push(obj)
      }
      // console.log(graphDataSectorPer);
      // console.log("allKeys")    
    }


    var keysSectorBreakdown = ["name", "value"]
    var length = productSectorBreakdown.length;
    for (let i = 1; i < length; i++) {
      // typeof(products[i][j])

      let obj = {};
      for (let j = 0; j < productSectorBreakdown[i].length; j++) {

        if (!isNaN(productSectorBreakdown[i][j])) {
          let val = productSectorBreakdown[i][j] * 100;

          // var numb= 212421434.533423131231;
          var rounded = Math.round((val + Number.EPSILON) * 100) / 100;

 
          obj[keysSectorBreakdown[j]] = rounded + '%';

        }

        // var updatedVal =  parseFloat(val).toFixed(2);
        // console.log(updatedVal);
        else {
          obj[keysSectorBreakdown[j]] = productSectorBreakdown[i][j];
        }

      }
      if (obj.value !== 0 + '%') {

        sectorBreakdownData.push(obj)

      }


      // console.log(graphDataSectorPer);
      // console.log("allKeys")

    }



    var keysVAR = ["name", "value"]
    var length = productSectorBreakdown.length

    for (let i = 1; i < length; i++) {
      // typeof(products[i][j])

      let obj = {};
      for (let j = 0; j < productSectorBreakdown[i].length; j++) {
        // if(productRegional[i][j]>0){
        if (!isNaN(productSectorBreakdown[i][j])) {
          let val = productSectorBreakdown[i][j];

          // var numb= 212421434.533423131231;
          var rounded1 = Math.round((val + Number.EPSILON) * 100) / 100;
          rounded1 = parseFloat(rounded1).toFixed(2);
          if (rounded1 == 0.00) {
            rounded1 = 0;
          }
          obj[keysVAR[j]] = rounded1 * 100;

        }

        // var updatedVal =  parseFloat(val).toFixed(2);
        // console.log(updatedVal);
        else {

          obj[keysVAR[j]] = productSectorBreakdown[i][j];
        }
        // }
      }
      if (obj.value !== 0) {
        graphDataResponse344.push(obj)

      }
      // console.log(graphData);
      // console.log("allKeys")

    }



    // setgraphData(graphDataResponse)
    setgraphData(graphDataResponse1)

    settop10HoldingState(top10HoldingData)
    setmarketCapState(marketCapData)
    setsectorBreakdownSDataState(graphDataResponse344)
    setInceptionArrayState2(InceptionDataArray2)
    setsectorBreakdownState(sectorBreakdownData)
    // setgraphDataSectorPer(graphDataResponse2)

    // console.log(graphDataResponse);
    // console.log("graphDataResponse");






    setportfolioStatus(true)





  }

  const Clicked = () => {
    $("#literatureTab").click();
    literatureButton();
  }
  const literatureButton = () => {

    let FundName;

    let LiteratureName;
    let FileName;
    let LiteratureDate;
    let LiteratureTitle;
    let FinancialTrendFund;
    let LiteratureSubHead;
    let OtherInfoLiteratureArr = [];
    let OtherSummaryInfoLiteratureArr = [];
    let KeyInveInfoLiteratureArr = [];
    let pressCoverageLiteratureArr = [];
    let applicationsLiteratureArr = [];
    let reportsLiteratureArr = [];
    let offerDocumentsLiteratureArr = [];

    var LiteratureKeys = ["LiteratureNameKey", "FileName", "LiteratureDate", "LiteratureTitle"];

    for (let i = 0; i < Literature.length; i++) {
      let OtherInfoObj = {};
      let KeyInveInfoObj = {};
      let pressCoverageObj = {};
      let applicationsObj = {};
      let reportsObj = {};
      let offerDocumentsObj = {};




      FundName = Literature[i].fund_name;
      if (FundName == "global_equity_fund") {

        if (Literature[i].literature_name == "other_information") {

          FinancialTrendFund = FundName;
          LiteratureTitle = Literature[i].title;
          LiteratureName = Literature[i].literature_name;
          FileName = Literature[i].file;
          LiteratureDate = Literature[i].date;

          OtherInfoObj[LiteratureKeys[0]] = LiteratureName;
          OtherInfoObj[LiteratureKeys[1]] = FileName;
          OtherInfoObj[LiteratureKeys[2]] = LiteratureDate;
          OtherInfoObj[LiteratureKeys[3]] = LiteratureTitle;

          OtherInfoLiteratureArr.push(OtherInfoObj);
        }
        if (Literature[i].literature_name == "other_information_summary") {

          FinancialTrendFund = FundName;
          LiteratureTitle = Literature[i].title;
          LiteratureName = Literature[i].literature_name;
          FileName = Literature[i].file;
          LiteratureDate = Literature[i].date;

          OtherInfoObj[LiteratureKeys[0]] = LiteratureName;
          OtherInfoObj[LiteratureKeys[1]] = FileName;
          OtherInfoObj[LiteratureKeys[2]] = LiteratureDate;
          OtherInfoObj[LiteratureKeys[3]] = LiteratureTitle;

          OtherSummaryInfoLiteratureArr.push(OtherInfoObj);
        }
        if (Literature[i].literature_name == "key_investor_information") {

          FinancialTrendFund = FundName;
          LiteratureTitle = Literature[i].title;
          LiteratureName = Literature[i].literature_name;
          FileName = Literature[i].file;
          LiteratureDate = Literature[i].date;

          KeyInveInfoObj[LiteratureKeys[0]] = LiteratureName;
          KeyInveInfoObj[LiteratureKeys[1]] = FileName;
          KeyInveInfoObj[LiteratureKeys[2]] = LiteratureDate;
          KeyInveInfoObj[LiteratureKeys[3]] = LiteratureTitle;

          KeyInveInfoLiteratureArr.push(KeyInveInfoObj);

        }
        if (Literature[i].literature_name == "press_Coverage") {

          FinancialTrendFund = FundName;
          LiteratureTitle = Literature[i].title;
          LiteratureName = Literature[i].literature_name;
          FileName = Literature[i].file;
          LiteratureDate = Literature[i].date;

          pressCoverageObj[LiteratureKeys[0]] = LiteratureName;
          pressCoverageObj[LiteratureKeys[1]] = FileName;
          pressCoverageObj[LiteratureKeys[2]] = LiteratureDate;
          pressCoverageObj[LiteratureKeys[3]] = LiteratureTitle;

          pressCoverageLiteratureArr.push(pressCoverageObj);

        }
        if (Literature[i].literature_name == "applications") {

          FinancialTrendFund = FundName;
          LiteratureTitle = Literature[i].title;
          LiteratureName = Literature[i].literature_name;
          FileName = Literature[i].file;
          LiteratureDate = Literature[i].date;

          applicationsObj[LiteratureKeys[0]] = LiteratureName;
          applicationsObj[LiteratureKeys[1]] = FileName;
          applicationsObj[LiteratureKeys[2]] = LiteratureDate;
          applicationsObj[LiteratureKeys[3]] = LiteratureTitle;

          applicationsLiteratureArr.push(applicationsObj);

        }
        if (Literature[i].literature_name == "reports") {

          FinancialTrendFund = FundName;
          LiteratureTitle = Literature[i].title;
          LiteratureName = Literature[i].literature_name;
          FileName = Literature[i].file;
          LiteratureDate = Literature[i].date;

          reportsObj[LiteratureKeys[0]] = LiteratureName;
          reportsObj[LiteratureKeys[1]] = FileName;
          reportsObj[LiteratureKeys[2]] = LiteratureDate;
          reportsObj[LiteratureKeys[3]] = LiteratureTitle;

          reportsLiteratureArr.push(reportsObj);

        }
        if (Literature[i].literature_name == "offering_documents") {

          FinancialTrendFund = FundName;
          LiteratureTitle = Literature[i].title;
          LiteratureName = Literature[i].literature_name;
          FileName = Literature[i].file;
          LiteratureDate = Literature[i].date;

          offerDocumentsObj[LiteratureKeys[0]] = LiteratureName;
          offerDocumentsObj[LiteratureKeys[1]] = FileName;
          offerDocumentsObj[LiteratureKeys[2]] = LiteratureDate;
          offerDocumentsObj[LiteratureKeys[3]] = LiteratureTitle;

          offerDocumentsLiteratureArr.push(offerDocumentsObj);

        }
        // FinancialTrendFund = FundName; 
        // LiteratureTitle = Literature[i].title;
        // LiteratureName = Literature[i].literature_name;
        // FileName = Literature[i].file;
        // LiteratureDate = Literature[i].date;


        // OtherInfoObj[LiteratureKeys[0]] = LiteratureName;
        // OtherInfoObj[LiteratureKeys[1]] = FileName;
        // OtherInfoObj[LiteratureKeys[2]] = LiteratureDate;
        // OtherInfoObj[LiteratureKeys[3]] = LiteratureTitle;



        // LiteratureArr.push(OtherInfoObj);

      }

    }


    setFundNameState(FinancialTrendFund);
    setLiteratureDataState(OtherInfoLiteratureArr);
    setLiteratureSummaryDataState(OtherSummaryInfoLiteratureArr);
    setKeyInveInfoState(KeyInveInfoLiteratureArr);
    setPressCoverageState(pressCoverageLiteratureArr);
    setApplicationsState(applicationsLiteratureArr);
    setReportsState(reportsLiteratureArr);
    setofferDocumentState(offerDocumentsLiteratureArr);






  }
  const tt = () => {
    // alert("hi");
    $('.btn-setting')[0].click();
  }

  const summaryButton = () => {

    let arrPRTU = []

    tt();
    var heading;
    var objective;
    var team;
    let daily_cal = PRTU[1][1]


    for (let i = 0; i < Summary.length; i++) {
      // typeof(products[i][j])
      if (Summary[i].heading == "global_equity_fund") {
        heading = Summary[i].heading;
        objective = Summary[i].objective_content;
        team = Summary[i].team_content;

      }



      // setTimeout()


      // console.log(graphData);
      // console.log("allKeys")


    }













    // For loop for calculation date
    let calculation = RespPrtu[1][2]
    // new Date(date).toLocaleDateString()
    let calculatedDate = new Date(calculation).toLocaleDateString("en-US", { day: 'numeric' }) + "/" + new Date(calculation).toLocaleDateString("en-US", { month: 'numeric' }) + "/" + new Date(calculation).toLocaleDateString("en-US", { year: 'numeric' });

   

    let DailycalculatedDate = new Date(daily_cal).toLocaleDateString("en-US", { day: 'numeric' }) + "/" + new Date(daily_cal).toLocaleDateString("en-US", { month: 'numeric' }) + "/" + new Date(daily_cal).toLocaleDateString("en-US", { year: 'numeric' });

    // for loop for Share price
    // for(let i=5;i<=8;i++){

    //   let val = PRTU[i][2]

    //   console.log(val);
    //   console.log("-----------------------------------ValVAL");

    //   arrPRTU.push(val)
    // }
    function useRegex(input) {
      let regex = /[a-zA-Z]+/i;
 
    }
    // var allKeys = ["name","date","currency","Price","ABC","XYZ","SOP","Eight","Nine","symbol","class"];
    var allKeys = ["name", "date", "class", "Price", "XD_price", "currency", "nav", "shares", "nav_USD", "symbol"];

    // var length =  products.length-1;
    for (let i = 1; i < PRTU.length; i++) {
      // typeof(products[i][j])

      let obj = {};
      for (let j = 0; j < PRTU[i].length; j++) {

        if (!isNaN(PRTU[i][j])) {
          let val = Number(PRTU[i][j]);
          // var numb= 212421434.533423131231;
          var rounded2 = Math.round((val + Number.EPSILON) * 100) / 100;

          obj[allKeys[j]] = rounded2;

        }
        // var updatedVal =  parseFloat(val).toFixed(2);
        // console.log(updatedVal);
        else {
          obj[allKeys[j]] = PRTU[i][j];
        }

      }

      if (obj.currency == "GBP") {
        obj[allKeys[9]] = "£";
      } else if (obj.currency == "EUR") {

        obj[allKeys[9]] = "€";

      } else if (obj.currency == "USD") {
        obj[allKeys[9]] = "$";

      } else if (obj.currency == "CHF") {
        obj[allKeys[9]] = "₣";
      }
       else if (obj.currency == "CNH") {
        obj[allKeys[9]] = "¥";
      }
      // function useRegex(input) {
      let regex_fund = /[a-zA-Z]+/i;
      // console.log(regex_fund.test(obj.name));
      // console.log("regex.test(input)");

      // }
      // useRegex(obj.name);
      // function useRegex(input) {
      let RegexHigh = /-/i;
      // console.log(RegexHigh.test(obj.name));
      // console.log("Regex.test(obj.name (-))");

      if (regex_fund.test(obj.name) && !RegexHigh.test(obj.name)) {



        var classShares = obj.name.split("Fund");
        // var classCurrency = classShares[1].split("(")
        // console.log(classCurrency)
        // console.log("classCurrency");
        obj[allKeys[10]] = classShares[1];
        // break;
        // obj[allKeys[8]] = classCurrency[1];
      } else if (RegexHigh.test(obj.name) && !regex_fund.test(obj.name)) {

        var classShares1 = obj.name.split("-");
        // var classCurrency = classShares[1].split("(")
        // console.log(classCurrency)
        // console.log("classCurrency");
        obj[allKeys[10]] = classShares1[1];
      }
      else if (regex_fund.test(obj.name) && RegexHigh.test(obj.name)) {

        var classShares2 = obj.name.split("Fund - ");
        obj[allKeys[10]] = classShares2[1];

      }
      arrPRTU.push(obj)

    }



    setarrPRTUState(arrPRTU)
    setPRTUDate(calculatedDate)
    setDailyDate(DailycalculatedDate)
    setStateSession(SessionResponse);

    setHeadingState(heading)
    setObjectiveState(objective)
    setTeamState(team)

    if (!arrPRTU.length > 0) {


      $(".daily-price-row").css("display", "none")
    } else {
      $(".daily-price-row").css("display", "block")
    }

    $('.footer-container').addClass('footer-container-line')
    literatureButton();
  }
  // $( document ).ready(function() {

  //   if (!arrPRTUState.length > 0) {


  //     $(".daily-price-row").css("display","none") 
  //   }
  //   });











  const performanceButton = () => {


    const CummulativeperformanceData = []
    const CummulativeperformanceBData = []
    const CummulativeperformanceBEURData = []
    const CummulativeperformanceBUSDData = []

    const CummulativeperformanceCData = []
    const CummulativeperformanceCEURData = []


    const TwelveMperfAGBP = []
    const TwelveMperfBGBP = []
    const TwelveMperfBEUR = []
    const TwelveMperfBUSD = []
    const TwelveMperfCGBP = []
    const TwelveMperfDEUR = []

    const InceptionDataArray = []


    // const Bot3contriData = []
    // const Top3contriData = []
    // const TwelvemonPerfData = []

    var monthsArr = [];
  

    for (let i = 7; i <= 21; i++) {
      monthsArr.push(productsMonthlyPerf[3][i])
    }
 

    var arr2D = [];
    for (let i = 4; i <= 16; i++) {
      let arr = []
      if (productsMonthlyPerf[i] == null) {
        arr2D.push(Array(14).fill(''));
        continue;
      }
      for (let j = 8; j <= 21; j++) {
        if (productsMonthlyPerf[i][j] != "") {
          let val = productsMonthlyPerf[i][j] * 100;

          var rounded = Math.round((val + Number.EPSILON) * 100) / 100;
          rounded = parseFloat(rounded).toFixed(2);
   
          if (isNaN(rounded)) {
            rounded = 0;
          

          }
          arr.push(rounded + '%')
        } else {
          if (productsMonthlyPerf[i][j] === 0) {
            let val1 = productsMonthlyPerf[i][j] * 100;
            var rounded1 = Math.round((val1 + Number.EPSILON) * 100) / 100;
            rounded1 = parseFloat(rounded1).toFixed(2);
            if (rounded1 == 0.00) {
              rounded1 = 0;
              arr.push(rounded1 + '%')
            }
          } else {
            rounded = '';
            arr.push(rounded)
          }
          // rounded = ''; 
          // arr.push(rounded)
        }

        // arr.push(productsMonthlyPerf[i][j])
      }
      arr2D.push(arr);
    }



    // var arrTwoD


    for (let i = 0; i < arr2D.length; i++) {
      for (let j = 0; j < arr2D[0].length; j++) {

        // console.log(arr2D[1][j])
        if (arr2D[i][j] == 0 + '%') {

          arr2D[i][j] = "0.00%"
        } else if (arr2D[i][j] == '') {
     
          arr2D[i][j] = " "
        }

      
      }
    }

 










    var monthsBArr = [];
    for (let i = 7; i <= 21; i++) {
      monthsBArr.push(productsMonthlyPerfB[3] != null ? productsMonthlyPerfB[3][i] : '')
    }
  

    var arrB2D = [];
    for (let i = 4; i <= 9; i++) {
      let arr = []
      for (let j = 8; j <= 21; j++) {
        if (productsMonthlyPerfB[i][j] != "") {
          let val = productsMonthlyPerfB[i][j] * 100;

          var rounded = Math.round((val + Number.EPSILON) * 100) / 100;
          rounded = parseFloat(rounded).toFixed(2);
          if (isNaN(rounded)) {
            rounded = 0;
          

          }
          arr.push(rounded + '%')
        } else {
          if (productsMonthlyPerfB[i][j] === 0) {
            let val1 = productsMonthlyPerfB[i][j] * 100;
            var rounded1 = Math.round((val1 + Number.EPSILON) * 100) / 100;
            rounded1 = parseFloat(rounded1).toFixed(2);
            if (rounded1 == 0.00) {
              rounded1 = 0;
              arr.push(rounded1 + '%')
            }
          } else {
            rounded = '';
            arr.push(rounded)
          }
          // rounded = ''; 
          // arr.push(rounded)
        }

        // arr.push(productsMonthlyPerf[i][j])
      }
      arrB2D.push(arr);
    }

    for (let i = 0; i < arrB2D.length; i++) {
      for (let j = 0; j < arrB2D[0].length; j++) {

        // console.log(arr2D[1][j])
        if (arrB2D[i][j] == 0 + '%') {
          arrB2D[i][j] = "0.00%"
        } else if (arrB2D[i][j] == '') {
          arrB2D[i][j] = " "
        }

      }
    }







    var monthsCArr = [];
    for (let i = 7; i <= 21; i++) {
      monthsCArr.push(productsMonthlyPerfC[3] != null ? productsMonthlyPerfC[3][i] : '')
    }

    var arrC2D = [];
    for (let i = 4; i <= 8; i++) {
      let arr = []
      for (let j = 8; j <= 21; j++) {
        if (productsMonthlyPerfC[i][j] != "") {
          let val = productsMonthlyPerfC[i][j] * 100;

          var rounded = Math.round((val + Number.EPSILON) * 100) / 100;
          rounded = parseFloat(rounded).toFixed(2);
          if (isNaN(rounded)) {
            rounded = 0;
      

          }
          arr.push(rounded + '%')

        } else {
          if (productsMonthlyPerfC[i][j] === 0) {
            let val1 = productsMonthlyPerfC[i][j] * 100;
            var rounded1 = Math.round((val1 + Number.EPSILON) * 100) / 100;
            rounded1 = parseFloat(rounded1).toFixed(2);
            if (rounded1 == 0.00) {
              rounded1 = 0;
              arr.push(rounded1 + '%')
            }
          } else {
            rounded = '';
            arr.push(rounded)
          }
          // rounded = ''; 
          // arr.push(rounded)
        }
        // arr.push(productsMonthlyPerf[i][j])
      }
      arrC2D.push(arr);
    }

    for (let i = 0; i < arrC2D.length; i++) {
      for (let j = 0; j < arrC2D[0].length; j++) {

        // console.log(arr2D[1][j])
        if (arrC2D[i][j] == 0 + '%') {
          arrC2D[i][j] = "0.00%"
        } else if (arrC2D[i][j] == '') {
          arrC2D[i][j] = " "
        }
      }
    }









    var monthsDArr = [];
    for (let i = 7; i <= 21; i++) {
      monthsDArr.push(productsMonthlyPerfBEUR[3] != null ? productsMonthlyPerfBEUR[3][i] : '')
    }


    var arrD2D = [];
    for (let i = 4; i <= 8; i++) {
      let arr = []
      if (productsMonthlyPerfBEUR[i] == null) {
        arrD2D.push(Array(14).fill(''));
        continue;
      }
      for (let j = 8; j <= 21; j++) {
        if (productsMonthlyPerfBEUR[i][j] != "") {
          let val = productsMonthlyPerfBEUR[i][j] * 100;

          var rounded = Math.round((val + Number.EPSILON) * 100) / 100;
          rounded = parseFloat(rounded).toFixed(2);
    
          if (isNaN(rounded)) {
            rounded = 0;
       

          }
          arr.push(rounded + '%')
        } else {
          if (productsMonthlyPerfBEUR[i][j] === 0) {
            let val1 = productsMonthlyPerfBEUR[i][j] * 100;
            var rounded1 = Math.round((val1 + Number.EPSILON) * 100) / 100;
            rounded1 = parseFloat(rounded1).toFixed(2);
            if (rounded1 == 0.00) {
              rounded1 = 0;
              arr.push(rounded1 + '%')
            }
          } else {
            rounded = '';
            arr.push(rounded)
          }
          // rounded = ''; 
          // arr.push(rounded)
        }

        // arr.push(productsMonthlyPerf[i][j])
      }
      arrD2D.push(arr);
    }

    for (let i = 0; i < arrD2D.length; i++) {
      for (let j = 0; j < arrD2D[0].length; j++) {

        // console.log(arr2D[1][j])
        if (arrD2D[i][j] == 0 + '%') {
          arrD2D[i][j] = "0.00%"
        } else if (arrD2D[i][j] == '') {
          arrD2D[i][j] = " "
        }
      }
    }




















    var keysCummulativePer = ["name", "value"]

    for (let i = 0; i < productscommulativePerformance.length; i++) {
      // typeof(products[i][j])

      let obj = {};
      for (let j = 0; j < productscommulativePerformance[i].length; j++) {

        if (!isNaN(productscommulativePerformance[i][j])) {
          let val = productscommulativePerformance[i][j] * 100;

          // var numb= 212421434.533423131231;
          var rounded = Math.round((val + Number.EPSILON) * 1000) / 1000;
          rounded = parseFloat(rounded).toFixed(2);
          obj[keysCummulativePer[j]] = rounded + '%';

        }

        // var updatedVal =  parseFloat(val).toFixed(2);
        // console.log(updatedVal);
        else {
          obj[keysCummulativePer[j]] = productscommulativePerformance[i][j];
        }

      }
      CummulativeperformanceData.push(obj)
      AbcObject = obj;


 


      // console.log("allKeys")

    }


    var keysCommulativePerfB = ["name", "value"]
    for (let i = 0; i < productscommulativePerformanceB.length; i++) {

      let obj = {};
      for (let j = 0; j < productscommulativePerformanceB[i].length; j++) {

        if (!isNaN(productscommulativePerformanceB[i][j])) {
          let val = productscommulativePerformanceB[i][j] * 100;

          // var numb= 212421434.533423131231;
          var rounded = Math.round((val + Number.EPSILON) * 1000) / 1000;
          rounded = parseFloat(rounded).toFixed(2);
   
          obj[keysCommulativePerfB[j]] = rounded + '%';
     
        }
        else {
          obj[keysCommulativePerfB[j]] = productscommulativePerformanceB[i][j];
        }

      }

      CummulativeperformanceBData.push(obj)

    }



    var keysCommPerfBEUR = ["name", "value"]
    for (let i = 0; i < productscommulativePerformanceBEUR.length; i++) {

      let obj = {};
      for (let j = 0; j < productscommulativePerformanceBEUR[i].length; j++) {

        if (!isNaN(productscommulativePerformanceBEUR[i][j])) {
          let val = productscommulativePerformanceBEUR[i][j] * 100;

          // var numb= 212421434.533423131231;
          var rounded = Math.round((val + Number.EPSILON) * 1000) / 1000;
          rounded = parseFloat(rounded).toFixed(2);
    
          obj[keysCommPerfBEUR[j]] = rounded + '%';

        }
        else {
          obj[keysCommPerfBEUR[j]] = productscommulativePerformanceBEUR[i][j];
        }

      }
      CummulativeperformanceBEURData.push(obj)



    }


    var keysCommPerfBUSD = ["name", "value"]
    for (let i = 0; i < productscommulativePerformanceBUSD.length; i++) {

      let obj = {};
      for (let j = 0; j < productscommulativePerformanceBUSD[i].length; j++) {

        if (!isNaN(productscommulativePerformanceBUSD[i][j])) {
          let val = productscommulativePerformanceBUSD[i][j] * 100;

          // var numb= 212421434.533423131231;
          var rounded = Math.round((val + Number.EPSILON) * 1000) / 1000;
          rounded = parseFloat(rounded).toFixed(2);
     
          obj[keysCommPerfBUSD[j]] = rounded + '%';

        }
        else {
          obj[keysCommPerfBUSD[j]] = productscommulativePerformanceBUSD[i][j];
        }

      }
      CummulativeperformanceBUSDData.push(obj)



    }



    var keysCommPerfC = ["name", "value"]

    for (let i = 0; i < productscommulativePerformanceC.length; i++) {
      // typeof(products[i][j])

      let obj = {};
      for (let j = 0; j < productscommulativePerformanceC[i].length; j++) {

        if (!isNaN(productscommulativePerformanceC[i][j])) {
          let val = productscommulativePerformanceC[i][j] * 100;

          // var numb= 212421434.533423131231;
          var rounded = Math.round((val + Number.EPSILON) * 1000) / 1000;
          rounded = parseFloat(rounded).toFixed(2);
  
          obj[keysCommPerfC[j]] = rounded + '%';

        }
        else {
          obj[keysCommPerfC[j]] = productscommulativePerformanceC[i][j];
        }

      }
      CummulativeperformanceCData.push(obj)

    }


    var keysCommPerfEUR = ["name", "value"]

    for (let i = 0; i < productscommulativePerformanceEUR.length; i++) {
      // typeof(products[i][j])

      let obj = {};
      for (let j = 0; j < productscommulativePerformanceEUR[i].length; j++) {

        if (!isNaN(productscommulativePerformanceEUR[i][j])) {
          let val = productscommulativePerformanceEUR[i][j] * 100;

          // var numb= 212421434.533423131231;
          var rounded = Math.round((val + Number.EPSILON) * 1000) / 1000;
          rounded = parseFloat(rounded).toFixed(2);
     
          obj[keysCommPerfEUR[j]] = rounded + '%';

        }
        else {
          obj[keysCommPerfEUR[j]] = productscommulativePerformanceEUR[i][j];
        }

      }
      CummulativeperformanceCEURData.push(obj)

    }




    var keys12monthsDis = ["name", "value"]



    for (let i = 0; i < twelvemonPerfAGBP.length; i++) {
      // typeof(products[i][j])

      let obj = {};
      for (let j = 0; j < twelvemonPerfAGBP[i].length; j++) {

        if (!isNaN(twelvemonPerfAGBP[i][j])) {
          let val = twelvemonPerfAGBP[i][j] * 100;

          // var numb= 212421434.533423131231;
          var rounded = Math.round((val + Number.EPSILON) * 1000) / 1000;
          rounded = parseFloat(rounded).toFixed(2);
       
          obj[keys12monthsDis[j]] = rounded + '%';

        }

        // var updatedVal =  parseFloat(val).toFixed(2);
        // console.log(updatedVal);
        else {
          obj[keys12monthsDis[j]] = twelvemonPerfAGBP[i][j];
        }

      }

      TwelveMperfAGBP.push(obj)
      AbcObject = obj;






      // console.log("allKeys")

    }

    var keys12monthsDisBGBP = ["name", "value"]

    for (let i = 0; i < twelvemonPerfBGBP.length; i++) {
      // typeof(products[i][j])

      let obj = {};
      for (let j = 0; j < twelvemonPerfBGBP[i].length; j++) {

        if (!isNaN(twelvemonPerfBGBP[i][j])) {
          let val = twelvemonPerfBGBP[i][j] * 100;

          // var numb= 212421434.533423131231;
          var rounded = Math.round((val + Number.EPSILON) * 1000) / 1000;
          rounded = parseFloat(rounded).toFixed(2);
 
          obj[keys12monthsDisBGBP[j]] = rounded + '%';

        }

        // var updatedVal =  parseFloat(val).toFixed(2);
        // console.log(updatedVal);
        else {
          obj[keys12monthsDisBGBP[j]] = twelvemonPerfBGBP[i][j];
        }

      }


      TwelveMperfBGBP.push(obj)
      AbcObject = obj;




      // console.log("allKeys")

    }

    var keys12monthsDisBEUR = ["name", "value"]

    for (let i = 0; i < twelvemonPerfBEUR.length; i++) {
      // typeof(products[i][j])

      let obj = {};
      for (let j = 0; j < twelvemonPerfBEUR[i].length; j++) {

        if (!isNaN(twelvemonPerfBEUR[i][j])) {
          let val = twelvemonPerfBEUR[i][j] * 100;

          // var numb= 212421434.533423131231;
          var rounded = Math.round((val + Number.EPSILON) * 1000) / 1000;
          rounded = parseFloat(rounded).toFixed(2);

          obj[keys12monthsDisBEUR[j]] = rounded + '%';

        }

        // var updatedVal =  parseFloat(val).toFixed(2);
        // console.log(updatedVal);
        else {
          obj[keys12monthsDisBEUR[j]] = twelvemonPerfBEUR[i][j];
        }

      }


      TwelveMperfBEUR.push(obj)


      // console.log("allKeys")

    }


    var keys12monthsDisBUSD = ["name", "value"]

    for (let i = 0; i < twelvemonPerfBUSD.length; i++) {
      // typeof(products[i][j])

      let obj = {};
      for (let j = 0; j < twelvemonPerfBUSD[i].length; j++) {

        if (!isNaN(twelvemonPerfBUSD[i][j])) {
          let val = twelvemonPerfBUSD[i][j] * 100;

          // var numb= 212421434.533423131231;
          var rounded = Math.round((val + Number.EPSILON) * 1000) / 1000;
          rounded = parseFloat(rounded).toFixed(2);

          obj[keys12monthsDisBUSD[j]] = rounded + '%';

        }

        // var updatedVal =  parseFloat(val).toFixed(2);
        // console.log(updatedVal);
        else {
          obj[keys12monthsDisBUSD[j]] = twelvemonPerfBUSD[i][j];
        }

      }


      TwelveMperfBUSD.push(obj)


      // console.log("allKeys")

    }


    var keys12monthsDisCGBP = ["name", "value"]

    for (let i = 0; i < twelvemonPerfCGBP.length; i++) {
      // typeof(products[i][j])

      let obj = {};
      for (let j = 0; j < twelvemonPerfCGBP[i].length; j++) {

        if (!isNaN(twelvemonPerfCGBP[i][j])) {
          let val = twelvemonPerfCGBP[i][j] * 100;

          // var numb= 212421434.533423131231;
          var rounded = Math.round((val + Number.EPSILON) * 1000) / 1000;
          rounded = parseFloat(rounded).toFixed(2);
          obj[keys12monthsDisCGBP[j]] = rounded + '%';

        }

        // var updatedVal =  parseFloat(val).toFixed(2);
        // console.log(updatedVal);
        else {
          obj[keys12monthsDisCGBP[j]] = twelvemonPerfCGBP[i][j];
        }

      }

      TwelveMperfCGBP.push(obj)


      // console.log("allKeys")

    }



    var keys12monthsDisDEUR = ["name", "value"]

    for (let i = 0; i < twelvemonPerfDEUR.length; i++) {
      // typeof(products[i][j])

      let obj = {};
      for (let j = 0; j < twelvemonPerfDEUR[i].length; j++) {

        if (!isNaN(twelvemonPerfDEUR[i][j])) {
          let val = twelvemonPerfDEUR[i][j] * 100;

          // var numb= 212421434.533423131231;
          var rounded = Math.round((val + Number.EPSILON) * 1000) / 1000;
          rounded = parseFloat(rounded).toFixed(2);
          obj[keys12monthsDisDEUR[j]] = rounded + '%';

        }

        // var updatedVal =  parseFloat(val).toFixed(2);
        // console.log(updatedVal);
        else {
          obj[keys12monthsDisDEUR[j]] = twelvemonPerfDEUR[i][j];
        }

      }

      TwelveMperfDEUR.push(obj)


      // console.log("allKeys")

    }


    var keysInceptionData = ["date", "value"]



    for (let i = 1; i < InceptionData.length; i++) {
      // typeof(products[i][j])

      let obj = {};
      if (InceptionData[i][13] != "") {
        var date = InceptionData[i][13]
        var AlphaDate = new Date(date).toLocaleDateString("en-US", { month: 'short' }) + "-" + new Date(date).toLocaleDateString("en-US", { year: 'numeric' })
      

        var PerformanceValue = InceptionData[i][17]


        obj[keysInceptionData[0]] = AlphaDate;
        obj[keysInceptionData[1]] = PerformanceValue * 100;

        InceptionDataArray.push(obj)

        //date = null
        //PerformanceValue = null
      }

    }


    setInceptionArrayState(InceptionDataArray)
    setcummulatovePerfData(CummulativeperformanceData)
    setcummulatovePerfBData(CummulativeperformanceBData)
    setCummulativeperfeBEURData(CummulativeperformanceBEURData)
    setCummulativeperfeBUSDData(CummulativeperformanceBUSDData)


    setCummulativeperfC(CummulativeperformanceCData)
    setCummulativeperfDEUR(CummulativeperformanceCEURData)


    setTwelveMperfAGBPState(TwelveMperfAGBP)
    setTwelveMperfBGBPState(TwelveMperfBGBP)
    setTwelveMperfBEURState(TwelveMperfBEUR)
    setTwelveMperfBUSDState(TwelveMperfBUSD)

    console.log("TwelveMperfCGBPState", TwelveMperfCGBP)
    setTwelveMperfCGBPState(TwelveMperfCGBP)
    setTwelveMperfDEURState(TwelveMperfDEUR)

    setmonthsArrayState(monthsArr)
    setmonthlyPerformance2DArrayState(arr2D)

    setmonthsBArrayState(monthsBArr)
    setmonthlyPerformanceB2DArrayState(arrB2D)

    setmonthsCArrayState(monthsCArr)
    setmonthlyPerformanceC2DArrayState(arrC2D)

    setmonthsDArrayState(monthsDArr)
    setmonthlyPerformanceD2DArrayState(arrD2D)




    // settwelvemonPerfDiscreteAPI(TwelvemonPerfData)
    // settop3contriarray(Top3contriData)
    // setbot3contriarray(Bot3contriData)





  }


  const informationButton = () => {
    const shareClassData = []
    const fundInfoData = []
    const CMSfundInfoData = []
    const CMSshareInfoData = []

    var keysCMSshareinfo = ["name", "ausdValue", "agbpValue", "aeurValue", "busdValue", "bgbpValue", "beurValue", "cgbpValue"]

    for (let j = 0; j < CMSshareinfo.length; j++) {
  

      let obj = {};
      obj[keysCMSshareinfo[0]] = CMSshareinfo[j].title;
      obj[keysCMSshareinfo[1]] = CMSshareinfo[j].ausd_value;
      obj[keysCMSshareinfo[2]] = CMSshareinfo[j].agbp_value;
      obj[keysCMSshareinfo[3]] = CMSshareinfo[j].aeur_value;
      obj[keysCMSshareinfo[4]] = CMSshareinfo[j].busd_value;
      obj[keysCMSshareinfo[5]] = CMSshareinfo[j].bgbp_value;
      obj[keysCMSshareinfo[6]] = CMSshareinfo[j].beur_value;
      obj[keysCMSshareinfo[7]] = CMSshareinfo[j].cgbp_value;


    

      CMSshareInfoData.push(obj)
    }

    var keysCMSFundinfo = ["name", "value"]

    for (let j = 0; j < CMSFundinfo.length; j++) {
   

      let obj = {};

      // KeyInveInfoObj[LiteratureKeys[0]] = LiteratureName;

      obj[keysCMSFundinfo[0]] = CMSFundinfo[j].title;
      obj[keysCMSFundinfo[1]] = CMSFundinfo[j].value;


    

      CMSfundInfoData.push(obj)
    }

    var keysShareClass = ["name", "value", "currency"]

    for (let i = 0; i < productsShareClass.length; i++) {
      // typeof(products[i][j])

      let obj = {};
      for (let j = 0; j < productsShareClass[i].length; j++) {

        if (!isNaN(productsShareClass[i][j]) && productsShareClass[i][j] != "") {
          let val = productsShareClass[i][j];

          // var numb= 212421434.533423131231;
          var rounded = Math.round((val + Number.EPSILON) * 100) / 100;

  
          obj[keysShareClass[j]] = rounded.toString().replace(/(^\d{1,3}|\d{3})(?=(?:\d{3})+(?:$|\.))/g, '$1,');
     
        }

        // var updatedVal =  parseFloat(val).toFixed(2);
        // console.log(updatedVal);
        else {
          if (productsShareClass[i][j] == "") {
          } else {
            obj[keysShareClass[j]] = productsShareClass[i][j];
          }
        }
        if (obj.name == "A GBP" || obj.name == "B GBP" || obj.name == "C GBP") {
          obj[keysShareClass[2]] = "£";
        } else if (obj.name == "A EUR" || obj.name == "B EUR") {

          obj[keysShareClass[2]] = "€";

        } else if (obj.name == "A USD" || obj.name == "B USD") {
          obj[keysShareClass[2]] = "$";

        }


      }
      if (Object.keys(obj).length != 0) {
        shareClassData.push(obj)
      }

    }


    var keysFundinfo = ["name", "value"]

    for (let i = 1; i < productsFundinfo.length; i++) {
      // typeof(products[i][j])

      let obj = {};
      for (let j = 0; j < productsFundinfo[i].length; j++) {

        if (!isNaN(productsFundinfo[i][j])) {
          let val = productsFundinfo[i][j] * 100;

          // var numb= 212421434.533423131231;
          var rounded = Math.round((val + Number.EPSILON) * 100) / 100;


          obj[keysFundinfo[j]] = rounded.toString().replace(/(^\d{1,3}|\d{3})(?=(?:\d{3})+(?:$|\.))/g, '$1,');
 
          var mrounded = Math.round((productsFundinfo[i][j] + Number.EPSILON) * 100) / 100;
          if (mrounded > 1000000) {
            var million_variable = (mrounded / 1000000).toFixed(2) + 'M'

            obj[keysFundinfo[j]] = '£' + million_variable;

          }
        }

        // var updatedVal =  parseFloat(val).toFixed(2);
        // console.log(updatedVal);
        else {
          obj[keysFundinfo[j]] = productsFundinfo[i][j];
        }

      }
      fundInfoData.push(obj)


    }

    setShareClassarray(shareClassData)
    setFundinfoarray(fundInfoData)


    setCMSFundinfoarray(CMSfundInfoData)
    setCMSshareinfoarray(CMSshareInfoData)








  }


  let AbcObject = {};

  let count = 0;
  async function fetchMyAPI() {

    //   if($("div").hassClass('footer-container-line')){

    //  }else{
    //   $("div").findClass('footer-container').addClass('footer-container-line')
    //  }
    // const fetchMyAPI = useCallback(() => {
    // https://epicipprojects.com/getdata  
    // https://jsonplaceholder.typicode.com/posts
    const Localurl = 'https://www.epicip.com/epic-global-equity-fund';
    const url = config.apiPath + '/epic-global-equity-fund'
    //const url = 'http://127.0.0.1:8000/epic-global-equity-fund'
    //const url = 'https://www.epicip.com/epic-global-equity-fund'
    //const url = 'https://demo.epicip.com/epic-global-equity-fund'

    // const url = 'https://epicipprojects.com/api/garraway-global-equity-fund' 

    fetch(config.apiPath + '/session_data').then(resp => resp.json()).then(resp => {


      setSessionResponse(resp);


    })
    fetch(url).then(resp => resp.json())
      .then(resp => {
    

        // setProducts(resp.SectorExposures)
        // setProductsVAR(resp.SectorVaR)
        // setProductsSectorPer(resp.SectorPerformance)
        setproductscommulativePerformance(resp.CumulativePerfClassAGBP)
        setproductscommulativePerformanceB(resp.CumulativePerfClassBGBP)
        setproductscommulativePerformanceBEUR(resp.CumulativePerfClassBEUR)
        setproductscommulativePerformanceBUSD(resp.CumulativePerfClassBUSD)

        setproductscommulativePerformanceC(resp.CumulativePerfClassCGBP)
        setproductscommulativePerformanceEUR(resp.CumulativePerfClassDEUR)


        settwelvemonPerfAGBP(resp.twelvemPerfDiscreteClassAGBP)
        settwelvemonPerfBGBP(resp.twelvemPerfDiscreteClassBGBP)
        settwelvemonPerfBEUR(resp.twelvemPerfDiscreteClassBEUR)
        settwelvemonPerfBUSD(resp.twelvemPerfDiscreteClassBUSD)
        settwelvemonPerfCGBP(resp.twelvemPerfDiscreteClassCGBP)
        settwelvemonPerfDEUR(resp.twelvemPerfDiscreteClassDEUR)

        setInceptionData(resp.InceptionPerfData);


        // setproducts12monthsPerformance(resp.twelvemPerfDiscrete)
        // setproductstop3contr(resp.Top3Contributors)
        // setproductsbot3contr(resp.Bottom3Contributors)
        setproductsCommentary(resp.content)
        setproductRegional(resp.RegionalWeightings)
        setproductstop10Holding(resp.TopHoldings)
        setproductsmarketCap(resp.MarketCapWeightings)
        setproductSectorBreakdown(resp.SectorWeightings)
        setproductsFundinfo(resp.FundSize)
        setproductsShareClass(resp.NAVperShare)
        setproductsMonthlyPerf(resp.MonthlyPerfAGBP)
        setproductsMonthlyPerfB(resp.MonthlyPerfBGBP)
        setproductsMonthlyPerfC(resp.MonthlyPerfCGBP)

        setproductsMonthlyPerfBEUR(resp.MonthlyPerfBEUR)


        // console.log(resp.prtu);
        setRespPrtu(resp.prtu)
        setPRTU(resp.daily_price)
        setSummary(resp.summary)
        setLiterature(resp.literature)
        setCMSFundinfo(resp.fund_info)
        setCMSshareinfo(resp.shareinfo)

        // setLoading(true)
        setstatus(true)



        document.getElementById("summaryButton").click();


      })

      .catch(e => {
   
      })
    // setresponseData(result)
    // .then( resp=>console.log(resp.SectorExposures))

    // console.log(responseData)
    // console.log("responseData")

    var keysMonthly = ["name"]
    var testArr = []
    var monthsValue = [[], []]
    var xArr = [[]]
    // var xArr = new Array(10);

    // for (var i = 0; i < xArr.length; i++) {
    //   xArr[i] = new Array(14);
    // }


    //   for(let y = 4; y < 13; y++){

    //     var count = 0;
    //     var moreCount = 0;  

    //     for(let z = 8; z < 22; z++){

    //       xArr[count][moreCount]= productsMonthlyPerf[y][z]
    //       // xArr.push(productsMonthlyPerf[y][z])

    //       moreCount++;
    //     }
    //     count++;


    //   }
    //   console.log(xArr);
    //   console.log("xArr");

    //   for(let x= 8; x < 22; x++){

    //   testArr.push(productsMonthlyPerf[3][x])

    // }
    // console.log(testArr)
    // console.log("testArr")


    //   for(let i=3 ; i< 14;i++){
    //    // typeof(products[i][j])

    //    let obj={};
    //    for(let j = 8 ;j< 22 ;j++){

    //      if(!isNaN(productsMonthlyPerf[i][j])){

    //      let val = productsMonthlyPerf[i][j]*100;
    //      console.log(productsMonthlyPerf[i][j])
    //      console.log("productsMonthlyPerf[i][j]productsMonthlyPerf[i][j]productsMonthlyPerf[i][j]productsMonthlyPerf[i][j]productsMonthlyPerf[i][j]productsMonthlyPerf[i][j]productsMonthlyPerf[i][j]productsMonthlyPerf[i][j]productsMonthlyPerf[i][j]")

    //      // var numb= 212421434.533423131231;
    //      var rounded = Math.round((val + Number.EPSILON) * 100) / 100;




    
    //      obj[keysMonthly[j]] = rounded ;
    //      console.log(obj);
    //      console.log("obj");
    //    }

    //      // var updatedVal =  parseFloat(val).toFixed(2);
    //      // console.log(updatedVal);
    //      else{
    //        obj[keysMonthly[j]] = productsMonthlyPerf[i][j] ;
    //      }     

    //      }
    //     //  ShareClassarray.push(obj)


    //     //  console.log(bot3contriarray);
    //     //  console.log("bot3contriarray");
    //     //  console.log(bot3contriDummy);
    //     //  console.log("bot3contriDummy");

    //                // console.log("allKeys")
    //  }  

    // For loops for displaying data
    //   var keysShareClass = ["name", "value"]

    //   for(let i=0 ; i< productsShareClass.length ;i++){
    //    // typeof(products[i][j])

    //    let obj={};
    //    for(let j =0 ;j< productsShareClass[i].length ;j++){

    //      if(!isNaN(productsShareClass[i][j])){
    //      let val = productsShareClass[i][j]*100;

    //      // var numb= 212421434.533423131231;
    //      var rounded = Math.round((val + Number.EPSILON) * 100) / 100;

    
    //      obj[keysShareClass[j]] = rounded ;
    //      console.log(obj);
    //      console.log("obj");
    //    }

    //      // var updatedVal =  parseFloat(val).toFixed(2);
    //      // console.log(updatedVal);
    //      else{
    //        obj[keysShareClass[j]] = productsShareClass[i][j] ;
    //      }     

    //      }
    //      ShareClassarray.push(obj)


    //      console.log(bot3contriarray);
    //      console.log("bot3contriarray");
    //      console.log(bot3contriDummy);
    //      console.log("bot3contriDummy");

    //                // console.log("allKeys")
    //  }  


    //   var keysFundinfo = ["name", "value"]

    //   for(let i=0 ; i< productsFundinfo.length ;i++){
    //    // typeof(products[i][j])

    //    let obj={};
    //    for(let j =0 ;j< productsFundinfo[i].length ;j++){

    //      if(!isNaN(productsFundinfo[i][j])){
    //      let val = productsFundinfo[i][j]*100;

    //      // var numb= 212421434.533423131231;
    //      var rounded = Math.round((val + Number.EPSILON) * 100) / 100;

    
    //      obj[keysFundinfo[j]] = rounded ;
    //      console.log(obj);
    //      console.log("obj");
    //    }

    //      // var updatedVal =  parseFloat(val).toFixed(2);
    //      // console.log(updatedVal);
    //      else{
    //        obj[keysFundinfo[j]] = productsFundinfo[i][j] ;
    //      }     

    //      }
    //      Fundinfoarray.push(obj)


    //      console.log(Fundinfoarray);
    //      console.log("Fundinfoarray");

    //  }




    //   var keysbot3contr = ["name", "value"]

    //   for(let i=0 ; i< productsbot3contr.length ;i++){
    //    // typeof(products[i][j])

    //    let obj={};
    //    for(let j =0 ;j< productsbot3contr[i].length ;j++){

    //      if(!isNaN(productsbot3contr[i][j])){
    //      let val = productsbot3contr[i][j]*100;

    //      // var numb= 212421434.533423131231;
    //      var rounded = Math.round((val + Number.EPSILON) * 100) / 100;

    
    //      obj[keysbot3contr[j]] = rounded ;
    //      console.log(obj);
    //      console.log("obj");
    //    }

    //      // var updatedVal =  parseFloat(val).toFixed(2);
    //      // console.log(updatedVal);
    //      else{
    //        obj[keysbot3contr[j]] = productsbot3contr[i][j] ;
    //      }     

    //      }
    //      bot3contriarray.push(obj)


    //      console.log(bot3contriarray);
    //      console.log("bot3contriarray");
    //      console.log(bot3contriDummy);
    //      console.log("bot3contriDummy");

    //                // console.log("allKeys")
    //  }
    // //  bot3contriDummy = [
    // //   {name: 'Short Euro / Swiss Franc', value: -0.34},
    // //   {name: 'Short Norwegian Krone / US Dollar', value: -0.31},
    // //   {name: 'Long Italian BTP', value: -0.29}
    // //  ]


    // //  bot3contriarray.push(productsbot3contr)

    // //  console.log("xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx")
    // //  console.log(productsbot3contr)




    //   var keystop3contr = ["name", "value"]

    //   for(let i=1 ; i< productstop3contr.length ;i++){
    //    // typeof(products[i][j])

    //    let obj={};
    //    for(let j =0 ;j< productstop3contr[i].length ;j++){

    //      if(!isNaN(productstop3contr[i][j])){
    //      let val = productstop3contr[i][j]*100;

    //      // var numb= 212421434.533423131231;
    //      var rounded = Math.round((val + Number.EPSILON) * 100) / 100;

    
    //      obj[keystop3contr[j]] = rounded ;

    //    }

    //      // var updatedVal =  parseFloat(val).toFixed(2);
    //      // console.log(updatedVal);
    //      else{
    //        obj[keystop3contr[j]] = productstop3contr[i][j] ;
    //      }     

    //      }
    //      top3contriarray.push(obj)


    //      console.log(top3contriarray);
    //      console.log("top3contriarray");
    //       // console.log("allKeys")

    //  } 


    //   var keys12monthsPer = ["name", "value"]

    //   for(let i=0 ; i< products12monthsPerformance.length ;i++){
    //    // typeof(products[i][j])

    //    let obj={};
    //    for(let j =0 ;j< products12monthsPerformance[i].length ;j++){

    //      if(!isNaN(products12monthsPerformance[i][j])){
    //      let val = products12monthsPerformance[i][j]*100;

    //      // var numb= 212421434.533423131231;
    //      var rounded = Math.round((val + Number.EPSILON) * 100) / 100;

    
    //      obj[keys12monthsPer[j]] = rounded ;

    //    }

    //      // var updatedVal =  parseFloat(val).toFixed(2);
    //      // console.log(updatedVal);
    //      else{
    //        obj[keys12monthsPer[j]] = products12monthsPerformance[i][j] ;
    //      }     

    //      }
    //      twelvemonPerfDiscreteAPI.push(obj)


    //      console.log(twelvemonPerfDiscreteAPI);
    //      console.log("twelvemonPerfDiscreteAPI");

    //                // console.log("allKeys")

    //  } 

    // var keysCummulativePer = ["name", "value"]

    //  for(let i=0 ; i< productscommulativePerformance.length ;i++){
    //   // typeof(products[i][j])

    //   let obj={};
    //   for(let j =0 ;j< productscommulativePerformance[i].length ;j++){

    //     if(!isNaN(productscommulativePerformance[i][j])){
    //     let val = productscommulativePerformance[i][j]*100;

    //     // var numb= 212421434.533423131231;
    //     var rounded = Math.round((val + Number.EPSILON) * 100) / 100;

    
    //     obj[keysCummulativePer[j]] = rounded ;

    //   }

    //     // var updatedVal =  parseFloat(val).toFixed(2);
    //     // console.log(updatedVal);
    //     else{
    //       obj[keysCummulativePer[j]] = productscommulativePerformance[i][j] ;
    //     }     

    //     }
    //     cummulatovePerfData.push(obj)
    //     AbcObject = obj;


    //     console.log(AbcObject)
    //     console.log("AbcObjectAbcObjectAbcObjectAbcObject")


    //     console.log(cummulatovePerfData);
    //     console.log("cummulatovePerfData");

    //               // console.log("allKeys")

    // } 



    // var keysSectorPer = ["name", "value"]

    //  for(let i=1 ; i< productsSectorPer.length ;i++){
    //   // typeof(products[i][j])

    //   let obj={};
    //   for(let j =0 ;j< productsSectorPer[i].length ;j++){

    //     if(!isNaN(productsSectorPer[i][j])){
    //     let val = productsSectorPer[i][j]*100;

    //     // var numb= 212421434.533423131231;
    //     var rounded = Math.round((val + Number.EPSILON) * 100) / 100;

    
    //     obj[keysSectorPer[j]] = rounded ;

    //   }

    //     // var updatedVal =  parseFloat(val).toFixed(2);
    //     // console.log(updatedVal);
    //     else{
    //       obj[keysSectorPer[j]] = productsSectorPer[i][j] ;
    //     }     

    //     }
    //     graphDataSectorPer.push(obj)


    //     console.log(graphDataSectorPer);
    //               // console.log("allKeys")

    // } 


    // var keysVAR = ["name", "value"]

    //  for(let i=1 ; i< productsVAR.length ;i++){
    //   // typeof(products[i][j])

    //   let obj={};
    //   for(let j =0 ;j< productsVAR[i].length ;j++){

    //     if(!isNaN(productsVAR[i][j])){
    //     let val = productsVAR[i][j]*100;

    //     // var numb= 212421434.533423131231;
    //     var rounded1 = Math.round((val + Number.EPSILON) * 100) / 100;

    //     console.log(rounded1);
    //     obj[keysVAR[j]] = rounded1 ;

    //   }

    //     // var updatedVal =  parseFloat(val).toFixed(2);
    //     // console.log(updatedVal);
    //     else{
    //       obj[keysVAR[j]] = productsVAR[i][j] ;
    //     }     

    //     } 
    //     graphDataVAR.push(obj)
    //     setstatus(true)
    //     // console.log(graphData);
    //     // console.log("allKeys")

    // }




    // var allKeys = ["name","current month","pevious month"];

    // for(let i=1 ; i< products.length ;i++){
    //   // typeof(products[i][j])

    //   let obj={};
    //   for(let j =0 ;j< products[i].length ;j++){

    //     if(!isNaN(products[i][j])){
    //     let val = products[i][j];
    //     // var numb= 212421434.533423131231;
    //     var rounded2 = Math.round((val + Number.EPSILON) * 100) / 100;

    //     console.log(rounded2);
    //     obj[allKeys[j]] = rounded2 ;

    //   }
    //     // var updatedVal =  parseFloat(val).toFixed(2);
    //     // console.log(updatedVal);
    //     else{
    //       obj[allKeys[j]] = products[i][j] ;
    //     }     

    //     }
    //     graphData.push(obj)

    //     // console.log(graphData);
    //     // console.log("allKeys")

    // }

  };

  // const dat = useMemo(()=>(AbcObject),[])





  const players = [
    {
      position: "forward",
      name: "Lebron",
      team: "Lakers"
    },
    {
      position: "forward",
      name: "Lebron",
      team: "Lakers"
    },
    {
      position: "forward",
      name: "Lebron",
      team: "Lakers"
    },
    {
      position: "forward",
      name: "Lebron",
      team: "Lakers"
    }
  ]

  const cummulatovePerfDatadummy = [
    {
      "name": "Class B GBP",
      "value": "Cumulative Performance"
    },
    {
      "name": "1m",
      "value": -1.29
    },
    {
      "name": "1Yr",
      "value": 1.04
    },
    {
      "name": "3Yr",
      "value": -2.41
    },
    {
      "name": "5Yr",
      "value": -19.6

    },
    {
      "name": "Since UCITS Strategy Relaunch",
      "value": 19.08
    },
    {
      "name": "Since Inception",
      "value": -3.37
    }
  ]

  const twelvemonPerfDatadummy = [
    {
      "name": "Class B GBP",
      "value": "Discrete Performance"
    },

    {
      "name": "30/06/2016 - 30/06/2017",
      "value": -5.09
    },
    {
      "name": "30/06/2017 - 30/06/2018",
      "value": -13.35
    },
    {
      "name": "30/06/2018 - 30/06/2019",
      "value": 2.26
    },
    {
      "name": "30/06/2019 - 30/06/2020",
      "value": -4.85
    },
    {
      "name": "30/06/2020 - 30/06/2021",
      "value": 3.5
    }
  ]

  const top3contriDummy = [
    {
      "name": "Long ASX SPI 200 Index",
      "value": 0.41,
      "undefined": 100
    },
    {
      "name": "Long S&P 500 Index",
      "value": 0.33,
      "undefined": 200
    },
    {
      "name": "Short Australian Dollar / New Zealand Dollar",
      "value": 0.3,
      "undefined": 300
    }
  ]
  // $(".accordion__item__header").on("click", function(event){    

  //   if(!$(this).hasClass("active")){

  //       $(".accordion__item__header.active").removeClass("active");   
  //       $(".collapse.show").removeClass("show");
  //       $(this).addClass("active")
  //       $(this).next(".collapse").addClass("show")

  //   }

  // })
  if ($(".accordion__item__header").length > 0) {

    var active = "active";
    var activedis = "active-dis";
    $(".accordion__item__header").on("click", function (event) {
      event.stopImmediatePropagation();

      $(this).toggleClass(active);
      $(this).find(".navlink").toggleClass(activedis);

      $(this).next("div").slideToggle(200);
    });
  }


  function renderTop10Holding(holding, index) {
    if (index == 0) {

      return (
        <tr className="AssetClass__Row-sc-1rmhbx4-5 eVXooJ">
          <th className="align-left">{holding.name}</th>
          <th colspan="1" className="align-right">{holding.value}</th>
        </tr>

      )

    } else {
      return (
        <tr className="AssetClass__Row-sc-1rmhbx4-5 eVXooJ" key={index}>
          <td className="align-left">{holding.name}</td>
          <td className="align-right">{holding.value}</td>

        </tr>


      )
    }
  }
  function renderMonthNames(months, index) {
    return (

      <th>{months}</th>
    )
  }
  function render12MonthsData(bot3contriparam, index) {
    // alert(bot3contriparam.name);
    for (let i = 0; i < bot3contriparam.length; i++) {
      return (
        <tr className="AssetClass__Row-sc-1rmhbx4-5 eVXooJ" key={index}>

          <td>{bot3contriparam[0].toString().slice(0, 4)}</td>
          <td>{bot3contriparam[1]}</td>
          <td>{bot3contriparam[2]}</td>
          <td>{bot3contriparam[3]}</td>
          <td>{bot3contriparam[4]}</td>
          <td>{bot3contriparam[5]}</td>
          <td>{bot3contriparam[6]}</td>
          <td>{bot3contriparam[7]}</td>
          <td>{bot3contriparam[8]}</td>
          <td>{bot3contriparam[9]}</td>
          <td>{bot3contriparam[10]}</td>
          <td>{bot3contriparam[11]}</td>
          <td>{bot3contriparam[12]}</td>
          <td>{bot3contriparam[13]}</td>



          {/* <td>{bot3contriparam.value}</td> */}
        </tr>
      )
    }
  }

  function renderMarketState(market, index) {
    return (
      <tr className="AssetClass__Row-sc-1rmhbx4-5 eVXooJ" key={index}>
        <td className="align-left">{market.name}</td>
        <td className="align-right">{market.value + '%'}</td>

      </tr>


    )
  }

  function renderSectorState(sector, index) {
    return (
      <tr className="AssetClass__Row-sc-1rmhbx4-5 eVXooJ" key={index}>
        <td className="align-left">{sector.name}</td>
        <td className="align-right">{sector.value}</td>

      </tr>


    )
  }










  // productscommulativePerformance
  function renderCummulativePerformanceNames(cummulatove, index) {
    if (index == 0) {

      return (

        <th className="align-center">{cummulatove.value}</th>

      )
    } else {
      return (

        <th className="align-center">{cummulatove.name}</th>

      )
    }
  }
  function renderCummulativePerformanceValue(cummulatove, index) {
    if (index == 0) {
      return (


        <td className="align-center">{cummulatove.name}</td>
      )
    } else {
      return (


        <td className="align-center">{cummulatove.value}</td>
      )
    }
  }
  function rendertwelvemonPerfDiscreteAPINames(twelvemon, index) {
    return (
      <th>{twelvemon.name}</th>
    )
  }
  function rendertwelvemonPerfDiscreteAPIValue(twelvemon, index) {
    return (
      <th>{twelvemon.value}</th>
    )
  }

  function rendertop3contri(top3contriparam, index) {
    return (
      <tr className="AssetClass__Row-sc-1rmhbx4-5 eVXooJ" key={index}>
        <td>{top3contriparam.name}</td>
        <td>{top3contriparam.value}</td>
      </tr>
    )
  }
  function renderbot3contri(bot3contriparam, index) {
    // alert(bot3contriparam.name);

    return (
      <tr className="AssetClass__Row-sc-1rmhbx4-5 eVXooJ" key={index}>

        <td>{bot3contriparam.name}</td>
        <td>{bot3contriparam.value}</td>
      </tr>
    )
  }
  function renderCMSshareinfo(shareinfoparam, index) {
    // alert(bot3contriparam.name);

    return (
      <tr className="Shares__Row-sc-1brks4f-2 eoQrEv" key={index}>

        <td className="align-left">{shareinfoparam.name}</td>
        {/* <td className="align-right">{shareinfoparam.ausdValue}</td> */}
        <td className="align-center">{shareinfoparam.agbpValue}</td>
        {/* <td className="align-right">{shareinfoparam.aeurValue}</td> */}
        {/* <td className="align-right">{shareinfoparam.busdValue}</td> */}
        <td className="align-center">{shareinfoparam.bgbpValue}</td>
        <td className="align-center">{shareinfoparam.beurValue}</td>
        <td className="align-center">{shareinfoparam.cgbpValue}</td>
        <td className="align-right">{shareinfoparam.busdValue}</td>

      </tr>
    )
  }

  function renderFundinfo(fundinfoparam, index) {
    // alert(bot3contriparam.name);

    return (
      <tr className="FundInformation__Row-sc-18irt95-2 fweCQL" key={index}>

        <td className="align-left">{fundinfoparam.name}</td>
        <td className="align-center">{fundinfoparam.value}</td>
      </tr>
    )
  }
  function renderShareClassNames(shareClass, index) {
    if (index == 0) {
      return (
        <th className="align-left">{shareClass.name}</th>
      )
    } else {
      return (
        <th className="align-center">{shareClass.name}</th>
      )
    }
  }
  function renderShareClassValue(shareClassValue, index) {
    if (index == 0) {
      return (
        <td className="align-left">{shareClassValue.currency}&nbsp;{shareClassValue.value}</td>
      )
    } else {
      return (
        <td className="align-center">{shareClassValue.currency}&nbsp;{shareClassValue.value}</td>
      )
    }
  }
  function renderDailyPrices(DailyPrice, index) {
    if (DailyPrice.Price !== 0) {
      return (
        <div key={index} className="DailyPricing__DailyPriceCard-sc-62f3gi-1 coIgZR">
          <div className="DailyPricing__DailyPrice-sc-62f3gi-2 gsZde">{DailyPrice.symbol}{DailyPrice.Price}</div>
          <div className="DailyPricing__DailyPriceName-sc-62f3gi-3 iLShEo">{DailyPrice.class}
            {/* <br/><span className="daily-span">(USD) Shares</span> */}
          </div>
        </div>
      )
    }
  }

  function renderLiteratureData(data, index) {
    return (

      <div className="col-sm-6">
        <p className="pdf_download"><a download href={config.apiPath + "/storage/literature-file/" + data.FileName} target="_blank">{data.LiteratureTitle}<br /><span className="date">{data.LiteratureDate}</span></a></p>
      </div>
    )
  }

  function renderLiteratureDataPO(data, index) {
    if (data.LiteratureNameKey == "other_information_summary") {
      return (

        <div className="col-sm-12" style={{ paddingLeft: "0px", paddingRight: "0px" }}>
          <p className="pdf_download"><a href={config.apiPath + "/storage/literature-file/" + data.FileName} target="_blank" download>{data.LiteratureTitle}</a></p>
        </div>
      )
    }
  }
  function renderLiteratureDataRecent(data, index) {
    if (index <= 1) {
      return (

        <div className="col-sm-6">
          <p className="pdf_download"><a href={config.apiPath + "/storage/literature-file/" + data.FileName} target="_blank" download>{data.LiteratureTitle}<br /><span className="date">{data.LiteratureDate}</span></a></p>
        </div>
      )
    }
  }

  function previewData(formData) {

    /* Add return before formData.map */
    return formData.map((item, key) => {
 
      return (
        <td>{item.name}</td>

        //  <div>{item.value}</div>
      )
    })
  }


  return (
    <Fragment>

      {status === true ?

        <section className="main-box">
          <div className="container">
            <div className="row">
              <div className="col-lg-3 col-md-3 col-sm-4">
                <Sidebar StateSession={{StateSession:StateSession,"url":"EpicglobalEquity","group":"Equities"}}/>
              </div>
              <div className="col-lg-8 col-md-8 col-sm-8 offset-md-1">
                <ul className="nav nav-tabs custom-nav-tabs   " role="tablist">
                  <li className="nav-item nav-item-tabs"> <a className="nav-link active" data-toggle="tab" id="summaryButton" href="#nine" onClick={summaryButton} role="tab">Summary</a> </li>
                  <li className="nav-item nav-item-tabs"> <a className="nav-link" data-toggle="tab" href="#eight" onClick={portfolioButton} role="tab">Portfolio</a> </li>
                  <li className="nav-item nav-item-tabs"> <a className="nav-link" data-toggle="tab" href="#one" onClick={performanceButton} role="tab">Performance</a> </li>

                  <li className="nav-item nav-item-tabs"> <a className="nav-link " data-toggle="tab" href="#two" role="tab">Commentary</a> </li>
                  <li className="nav-item nav-item-tabs"> <a className="nav-link" data-toggle="tab" href="#three" onClick={informationButton} role="tab">Information</a> </li>
                  <li className="nav-item nav-item-tabs"> <a className="nav-link" data-toggle="tab" href="#four" id="literatureTab" onClick={literatureButton} role="tab">Literature</a> </li>
                </ul>
                <div className="tab-content">
                  <div className="tab-pane fade active show" id="nine" role="tabpanel">
                    <div className="row">
                      <div className="col-sm-12">
                        <div role="tabpanel" aria-hidden="false" className="fade tab-pane active show">

                          <div className="row">
                            <div className="col">
                              <div className="Paragraph__ParagraphContainer-sc-2ra4j2-0 gnBxSc">
                                <div>
                                  {LiteratureSummaryDataState.length > 0 ? <div><h3><b>Product Overview</b></h3></div> : ""}
                                  {LiteratureSummaryDataState.length > 0 ? LiteratureSummaryDataState.map(renderLiteratureDataPO) : ""}
                                </div>
                              </div>
                            </div>
                            <div className="col-md-12">
                              {PressCoverageState.length > 0 ? <h3><b>Recent Updates</b></h3> : ""}
                            </div>
                            {PressCoverageState.length > 0 ? PressCoverageState.map(renderLiteratureDataRecent) : ""}
                            <div className="col-md-12"></div>
                            {/* <div className="col">
                        <div className="Paragraph__ParagraphContainer-sc-2ra4j2-0 gnBxSc">
                            <div>
                                <h3 className="Paragraph__Heading-sc-2ra4j2-2 dfMrdv">Fund Objectives</h3>
                                <div className="Paragraph__NormalParagraph-sc-2ra4j2-1 dISjjZ">
                                    <p className="Paragraph__Body-sc-2ra4j2-4 gIzxtZ">
                                        The Fund seeks to provide capital appreciation over the medium term with a target annualised volatility of 15%. It aims to perform independently of traditional stock and bond investments, thereby providing valuable diversification benefits and potentially improving the risk/reward profile of a traditional portfolio. 
                                    </p>
                                </div>
                            </div>
                            <span>Key Investor Information can be found 
                                <button className="FundInformation__ButtonLink-sc-1gcw03z-0 iZcztK">here</button>.
                            </span>
                            <div>
                                <h3 className="Paragraph__Heading-sc-2ra4j2-2 dfMrdv">Trading Strategy</h3>
                                <div className="Paragraph__NormalParagraph-sc-2ra4j2-1 dISjjZ">
                                    <p className="Paragraph__Body-sc-2ra4j2-4 gIzxtZ">The investment manager employs a systematic, proprietary, trend following strategy which trades across global UCITS eligible exchange traded financial futures.</p>
                                </div>
                            </div>
                        </div>
                    </div> */}

                            {/* <div role="tabpanel" aria-hidden="false" className="fade tab-pane active show"> */}
                            {/* <div classes="mb-1" className="row"> */}
                            <div className="col">
                              <div className="Paragraph__ParagraphContainer-sc-2ra4j2-0 gnBxSc">
                                <div>

                                  {/* <h3 className="Paragraph__Heading-sc-2ra4j2-2 dfMrdv">{HeadingState}</h3> */}
                                  <div className="Paragraph__NormalParagraph-sc-2ra4j2-1 dISjjZ" dangerouslySetInnerHTML={{ __html: ObjectiveState }}>

                                    {/* <p className="Paragraph__Body-sc-2ra4j2-4 gIzxtZ" dangerouslySetInnerHTML={{ __html: ObjectiveState }}>
                                                
                                            </p> */}
                                  </div>
                                </div>
                                <span>
                                  Key Investor Information can be found
                                  <a href="#" onClick={Clicked} className="InvestorInfo a">&nbsp;here</a>.
                                </span><br /><br />
                                {/* <div>
                                        <h3 className="Paragraph__Heading-sc-2ra4j2-2 dfMrdv">Trading Strategy</h3>
                                        <div className="Paragraph__NormalParagraph-sc-2ra4j2-1 dISjjZ">
                                            <p className="Paragraph__Body-sc-2ra4j2-4 gIzxtZ">
                                                The investment manager employs a systematic, proprietary, trend following strategy which trades across global UCITS eligible exchange traded financial futures.
                                            </p>
                                        </div>
                                    </div> */}
                              </div>
                            </div>
                            {/* </div> */}
                            <div className="row margin-1 daily-price-row">
                              <div className="col">
                                <div>
                                  <h3 className="Paragraph__Heading-sc-2ra4j2-2 ">Daily Prices</h3>
                                  <div className="DailyPricing__Boxes-sc-62f3gi-0 biswZj">
                                    {arrPRTUState.map(renderDailyPrices)}

                                    {/* </div> */}
                                  </div>

                                  <div className="DailyPricing__SourceWrapper-sc-62f3gi-4 hfRiYK">
                                    <p className="mt-2">Data as at: {DailyDate}<br />
                                      <span className="mt-1">Source: EPIC Investment Partners (Ireland) Limited</span></p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="row margin-1">
                              <div className="col">
                                <h3 className="Paragraph__Heading-sc-2ra4j2-2">Investment Team</h3>
                                {/* <h3 className="Paragraph__SubHeading-sc-2ra4j2-3 dtCYUm">Darran Goodwin - Fund Manager</h3> */}
                                <p className="Paragraph__Body-sc-2ra4j2-4 gIzxtZ" dangerouslySetInnerHTML={{ __html: TeamState }}>

                                </p>

                              </div>
                            </div>
                            {/* </div> */}




                          </div>
                        </div>
                        {/* <div className="row">
                    <div className="col">
                        <h3 className="Paragraph__Heading-sc-2ra4j2-2 dfMrdv">Investment Team</h3>
                        <h3 className="Paragraph__SubHeading-sc-2ra4j2-3 dtCYUm">Mark Harris - Fund Manager</h3>
                        <p className="Paragraph__Body-sc-2ra4j2-4 gIzxtZ">Mark is the lead Fund Manager of Garraway’s range of multi-asset funds. Mark joined Garraway in 2019 from City Financial where he headed the multi-asset team, joining in October 2012 as part of its acquisition of Eden Asset Management. He joined Eden in 2011 to head its multi-asset business. In 2009, he joined Henderson following its acquisition of New Star Asset Management, leading a team of six managing over £2 billion in assets across a range of low to high-risk mandates. He had previously spent six years at New Star Asset Management managing a range of award-winning funds. Mark has a degree in Law and Economics from Newcastle University.</p>
                        <h3 className="Paragraph__SubHeading-sc-2ra4j2-3 dtCYUm">Pushpanshu Prakash - Senior Investment Analyst</h3>
                        <p className="Paragraph__Body-sc-2ra4j2-4 gIzxtZ">Pushpanshu joined Garraway in 2019 from City Financial where he was a fund analyst for the Multi Asset team responsible for fund specific research and quantitative modelling. He joined City Financial in 2017 after graduating from University College London (UCL) with an MSci in Mathematics, where he completed his thesis in fluid dynamics with a focus on situational modelling and financial mathematics. Prior to starting his career in financial services, he completed internships at the UCL School of Management, Atlantic Trading and Procter &amp; Gamble.</p>
                    </div>
                </div> */}

                      </div>

                    </div>
                  </div>
                  <div className="tab-pane fade" id="eight" role="tabpanel">
                    <div className="row chart-row">
                      {/*<div className="col-md-6 "> 
          <table className="AssetClass__Table-sc-1rmhbx4-3 iiGyjE ">
            <tbody className="AssetClass__Body-sc-1rmhbx4-4 cyhKrw">
              {/* <tr className="AssetClass__Row-sc-1rmhbx4-5 eVXooJ">
                <th colspan="1">Top 10 Holdings</th>
                <th colspan="1" className="align-right">% NAV</th>
              </tr> */}
                      {/* <tr className="AssetClass__Row-sc-1rmhbx4-5 eVXooJ"> */}

                      {/*{top10HoldingState.map(renderTop10Holding)} */}

                      {/* <td>Microsoft</td>
                <td>7.46%</td> */}
                      {/* </tr> */}
                      {/* <tr className="AssetClass__Row-sc-1rmhbx4-5 eVXooJ">
                <td>PayPal Holdings</td>
                <td>5.54%</td>
              </tr> */}
                      {/* <tr className="AssetClass__Row-sc-1rmhbx4-5 eVXooJ">
                <td>JD Sports Fashion</td><td>5.06%</td></tr><tr className="AssetClass__Row-sc-1rmhbx4-5 eVXooJ"><td>Adobe</td><td>4.82%</td></tr><tr className="AssetClass__Row-sc-1rmhbx4-5 eVXooJ"><td>Mastercard</td><td>4.65%</td></tr><tr className="AssetClass__Row-sc-1rmhbx4-5 eVXooJ"><td>Amazon.com</td><td>4.64%</td></tr><tr className="AssetClass__Row-sc-1rmhbx4-5 eVXooJ"><td>Visa</td><td>4.62%</td></tr><tr className="AssetClass__Row-sc-1rmhbx4-5 eVXooJ"><td>Facebook</td><td>4.58%</td></tr><tr className="AssetClass__Row-sc-1rmhbx4-5 eVXooJ"><td>Coloplast</td><td>3.50%</td></tr><tr className="AssetClass__Row-sc-1rmhbx4-5 eVXooJ"><td>Veeva Systems</td><td>3.13%</td></tr> */}
                      {/*</tbody></table>
                      </div>*/}
                      <div className="col-md-6 SECmargin chart-block">
                        <p className="lse_redirect">Top 10 Holdings (% NAV)</p>
                        <p className="lse_redirect"><a className="display-none" target="_blank" href="transaction-own-share.php">Transaction In Own Share</a></p>

                        <PieChart width={300} height={330} margin={{ top: -60, right: 50, bottom: 5, left: 0 }} >
                          <Pie
                            data={InceptionArrayState2}
                            cx={90}
                            cy={200}
                            innerRadius={45}
                            outerRadius={90}
                            // fill="#0c2340"
                            paddingAngle={0}
                            startAngle={90}
                            endAngle={-330}
                            dataKey="value"
                            labelLine={false}
                            label={renderCustomized12LabelFixed}

                          >
                            {InceptionArrayState2.map((entry, index) => (
                              <Cell key={`cell-${index}`} fill={DONUTCOLORS8[index % DONUTCOLORS8.length]} />
                            ))}
                          </Pie>
                          <Legend margin={{ top: -500, }} className="legend-text" formatter={renderColor12fulLegendText} iconSize={10} width={300} height={50} layout='vertical' />

                          <Tooltip />
                          {/* <Legend /> */}
                        </PieChart>


                      </div>
                      <div className="col-md-6 VARmargin chart-block">
                        <p className="lse_redirect">Regional Breakdown (% NAV)</p>
                        <p className="lse_redirect"><a className="display-none" target="_blank" href="transaction-own-share.php">Transaction In Own Share</a></p>
                        <PieChart width={300} height={330} margin={{ top: -60, right: 50, bottom: 5, left: 0 }} >

                          <Pie
                            data={graphData}
                            cx={90}
                            cy={200}
                            innerRadius={45}
                            outerRadius={90}
                            // fill="#0c2340"
                            paddingAngle={0}
                            startAngle={90}
                            endAngle={-330}
                            dataKey="value"
                            labelLine={false}
                            label={renderCustomizedLabel}
                          >
                            {/* <Label value="website"  position="outside" /> */}
                            {graphData.map((entry, index) => (
                              <Cell key={`cell-${index}`} fill={DONUTCOLORS5[index % DONUTCOLORS5.length]} />
                            ))}

                          </Pie>
                          <Label position="inside" dataKey="name" />
                          <Legend className="legend" margin={{ top: -500, left: -150 }} formatter={renderColorfulLegendText} iconSize={10} width={300} height={50} layout='vertical' />


                          <Tooltip />
                          {/* <Legend /> */}
                        </PieChart>
                      </div>
                      <div className="col-md-6 TOPmargin chart-block">
                        <p className="lse_redirect">Market Cap Breakdown (% NAV)</p>
                        <p className="lse_redirect"><a className="display-none" target="_blank" href="transaction-own-share.php">Transaction In Own Share</a></p>


                        <PieChart width={300} height={330} margin={{ top: -60, right: 50, bottom: 5, left: 0 }} >
                          <Pie
                            data={marketCapState}
                            cx={90}
                            cy={200}
                            innerRadius={45}
                            outerRadius={90}
                            // fill="#0c2340"
                            paddingAngle={0}
                            startAngle={90}
                            endAngle={-330}
                            dataKey="value"
                            labelLine={false}
                            label={renderCustomizedLabelFixed}

                          >
                            {marketCapState.map((entry, index) => (
                              <Cell key={`cell-${index}`} fill={DONUTCOLORS6[index % DONUTCOLORS6.length]} />
                            ))}
                          </Pie>
                          <Legend margin={{ top: -500, }} className="legend-text" formatter={renderColorfulLegendText} iconSize={10} width={300} height={50} layout='vertical' />

                          <Tooltip />
                          {/* <Legend /> */}
                        </PieChart>


                      </div>
                      <div className="col-md-6 chart-block">
                        <p className="lse_redirect">Sector Breakdown (% NAV)</p>


                        <PieChart width={300} height={330} margin={{ top: -60, right: 50, bottom: 5, left: 0 }} >
                          <Pie
                            data={sectorBreakdownSData}
                            cx={90}
                            cy={200}
                            innerRadius={45}
                            outerRadius={90}
                            // fill="#0c2340"
                            paddingAngle={0}
                            startAngle={90}
                            endAngle={-330}
                            dataKey="value"
                            labelLine={false}
                            label={renderCustomizedLabel}
                          >
                            {sectorBreakdownSData.map((entry, index) => (
                              <Cell key={`cell-${index}`} fill={DONUTCOLORS9[index % DONUTCOLORS9.length]} />
                            ))}
                          </Pie>
                          <Tooltip />
                          {/* <Legend /> */}

                          <Legend formatter={renderColorfulLegendText} className="legend-text" iconSize={10} width={300} height={50} layout='vertical' />
                        </PieChart>
                      </div>
                    </div>
                    <div className="row chart-row" style={{ marginTop: "-10px" }}>
                      {/* <div className="col-md-6 MarketcapBreakmargin"> 

          <table className="AssetClass__Table-sc-1rmhbx4-3 mt iiGyjE">
            <tbody className="AssetClass__Body-sc-1rmhbx4-4 cyhKrw">
              <tr className="AssetClass__Row-sc-1rmhbx4-5 fQKjoJ">
                <th colspan="99">Market Cap Breakdown</th>
              </tr>
              

              {marketCapState.map(renderMarketState)}
              {/* <tr className="AssetClass__Row-sc-1rmhbx4-5 eVXooJ">
                
                <td>Mega</td><td>50.15%</td></tr><tr className="AssetClass__Row-sc-1rmhbx4-5 eVXooJ"><td>Large</td><td>46.72%</td>
              </tr> */}
                      {/*</tbody>
          </table>
          
          </div>*/}
                      {/*<div className="col-md-6 SECbreakmargin "> 
          <table className="AssetClass__Table-sc-1rmhbx4-3 iiGyjE iiGyjE_newonces">
            <tbody className="AssetClass__Body-sc-1rmhbx4-4 cyhKrw">
              <tr className="AssetClass__Row-sc-1rmhbx4-5 fQKjoJ">
                <th colspan="99">Sector Breakdown</th>
              </tr>
              {sectorBreakdownState.map(renderSectorState)}
            </tbody></table>
          
        </div>*/}

                    </div>
                    <div className="DailyPricing__SourceWrapper-sc-62f3gi-4 hfRiYK">
                      <p className="mt-2 i">Monthly data as at: {PRTUDate}.
                        All information also available to download <a href={config.apiPath + "/sitepdfs/epic_global_equity_fund.pdf"} target="_blank" download>here </a>
                        <br /></p>
                    </div>
                  </div>
                  <div className="tab-pane fade" id="one" role="tabpanel">
                    <div className="row">

                      <div className="col-sm-12">
                        <div role="tabpanel" aria-hidden="false" className="fade tab-pane active show">

                          <div className="row chart-row">
                            <div className="col-md-12 chart-block " >
                              <p className="lse_redirect">Cumulative Performance Since Inception</p>
                              <LineChart
                                width={700}
                                height={260}
                                data={InceptionArrayState}
                                margin={{
                                  top: 5,
                                  right: 30,
                                  left: -20,
                                  bottom: 5
                                }}
                              >
                                <CartesianGrid horizontal="true" vertical="" strokeDasharray=" " />
                                <XAxis dataKey="date" type="category" />
                                <YAxis tickFormatter={(tick) => {
                                  return `${tick}%`;
                                }}
                                />
                                {/* <Tooltip /> */}
                                {/* <Legend /> */}
                                <Line
                                  type="monotone"
                                  dataKey="value"
                                  stroke="#1a2352"
                                  dot={false}
                                  activeDot={{ r: 4 }}
                                />

                              </LineChart>
                              <p className="lse_redirect1"><span className="span_color"> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>&nbsp;&nbsp; EPIC Global Equity Fund Class B GBP</p>
                            </div>
                          </div>
                          <div className="row chart-row">
                            <div className="col-md-12 table-margin table-margin_new table-responsive">
                              <table className=" table  CumulativePerformance__Table-sc-51pab9-0 hRUkzz hRUkzz_newest">
                                <tbody>
                                  <tr className="CumulativePerformance__TopRow-sc-51pab9-1 dwdfBh">

                                    {cummulatovePerfData.map(renderCummulativePerformanceNames)}

                                  </tr>
                                  {/* <tr className="CumulativePerformance__BottomRow-sc-51pab9-2 eeFpGK">
              
                                  {cummulatovePerfData.map(renderCummulativePerformanceValue)}

                                </tr> */}

                                  <tr className="CumulativePerformance__BottomRow-sc-51pab9-2 eeFpGK">

                                    {cummulatovePerfBData.map(renderCummulativePerformanceValue)}

                                  </tr>
                                  <tr className="CumulativePerformance__BottomRow-sc-51pab9-2 eeFpGK">

                                    {CummulativeperfeBEURData.map(renderCummulativePerformanceValue)}

                                  </tr>
                                  <tr className="CumulativePerformance__BottomRow-sc-51pab9-2 eeFpGK">

                                    {CummulativeperfeBUSDData.map(renderCummulativePerformanceValue)}

                                  </tr>
                                  <tr className="CumulativePerformance__BottomRow-sc-51pab9-2 eeFpGK">

                                    {CummulativeperfC.map(renderCummulativePerformanceValue)}

                                  </tr>

                                  <tr className="CumulativePerformance__BottomRow-sc-51pab9-2 eeFpGK">

                                    {CummulativeperfDEUR.map(renderCummulativePerformanceValue)}

                                  </tr>


                                </tbody>
                              </table>
                            </div>
                          </div>


                          <div className="row chart-row">
                            <div className="col-md-12 table-margin_new table-responsive" >
                              <table className=" table  CumulativePerformance__Table-sc-51pab9-0 hRUkzz hRUkzz_newest">
                                <tbody>
                                  <tr className="CumulativePerformance__TopRow-sc-51pab9-1 dwdfBh">

                                    {TwelveMperfBGBPState.map(renderCummulativePerformanceNames)}

                                  </tr>
                                  {/* <tr className="CumulativePerformance__BottomRow-sc-51pab9-2 eeFpGK">
              
                                  {TwelveMperfAGBPState.map(renderCummulativePerformanceValue)}

                                </tr> */}

                                  <tr className="CumulativePerformance__BottomRow-sc-51pab9-2 eeFpGK">

                                    {TwelveMperfBGBPState.map(renderCummulativePerformanceValue)}

                                  </tr>
                                  <tr className="CumulativePerformance__BottomRow-sc-51pab9-2 eeFpGK">

                                    {TwelveMperfBEURState.map(renderCummulativePerformanceValue)}

                                  </tr>
                                  <tr className="CumulativePerformance__BottomRow-sc-51pab9-2 eeFpGK">

                                    {TwelveMperfBUSDState.map(renderCummulativePerformanceValue)}

                                  </tr>
                                  <tr className="CumulativePerformance__BottomRow-sc-51pab9-2 eeFpGK">
                                    {/* {TwelveMperfCGBPState.slice(0, 6).map(renderCummulativePerformanceValue)} */}
                                    {TwelveMperfCGBPState.filter((_, i) => i !== 3 && i !== 4 && i !== 5).slice(0, 6).map(renderCummulativePerformanceValue)} 
                                  </tr>
                                  <tr className="CumulativePerformance__BottomRow-sc-51pab9-2 eeFpGK">

                                    {TwelveMperfDEURState.map(renderCummulativePerformanceValue)}

                                  </tr>


                                </tbody>
                              </table>
                            </div>
                          </div>



                          <div className="row">
                            <div className="col-md-12 mergin_new_table" >
                              {/* <div className="MonthlyPerformance__Wrapper-sc-1n33bhd-0 cHAvbZ">
                        <table className=" MonthlyPerformance__Table-sc-1n33bhd-2 bDbyAW">
                                <tbody className="table MonthlyPerformance__Body-sc-1n33bhd-3 eLhmcV">
                                    <tr>
                                        <th colspan="99" className="MonthlyPerformance__Title-sc-1n33bhd-1 ekfIgT">
                                            Monthly Performance – Class A GBP</th>
                                    </tr>
                                    <tr color="#d8e2e8" className="MonthlyPerformance__Row-sc-1n33bhd-4 elqUjA">

                                        {monthsArrayState.map(renderMonthNames)}
                                    
                                    </tr>
                                    

                                </tbody>
                            </table>

                            <table className="table MonthlyPerformance__Table-sc-1n33bhd-2 bDbyAW table-striped">
                                <tbody className="table MonthlyPerformance__Body-sc-1n33bhd-3 eLhmcV">
                                    
                                    {monthlyPerformance2DArrayState.map(render12MonthsData)}

                                    {/* </tr> */}
                              {/*</tbody>
                            </table>
                        </div> */}
                            </div>
                            <div className="col-md-12 mergin_new_table" >

                              <div className="MonthlyPerformance__Wrapper-sc-1n33bhd-0 cHAvbZ table-responsive">
                                <table className=" MonthlyPerformance__Table-sc-1n33bhd-2 bDbyAW">
                                  <tbody className="table MonthlyPerformance__Body-sc-1n33bhd-3 eLhmcV">
                                    <tr>
                                      <th colspan="99" className="MonthlyPerformance__Title-sc-1n33bhd-1 ekfIgT">
                                        Monthly Performance – Class B GBP</th>
                                    </tr>
                                    <tr color="#d8e2e8" className="MonthlyPerformance__Row-sc-1n33bhd-4 elqUjA">

                                      {monthsBArrayState.map(renderMonthNames)}

                                    </tr>

                                  </tbody>
                                </table>

                                <table className="table MonthlyPerformance__Table-sc-1n33bhd-2 bDbyAW table-striped">
                                  <tbody className="table MonthlyPerformance__Body-sc-1n33bhd-3 eLhmcV">

                                    {/* <tr className="MonthlyPerformance__Row-sc-1n33bhd-4 oKXFa"> */}

                                    {monthlyPerformanceB2DArrayState.map(render12MonthsData)}

                                    {/* </tr> */}
                                  </tbody>
                                </table>
                              </div>
                            </div>


                            <div className="col-md-12 mergin_new_table" >

                              <div className="MonthlyPerformance__Wrapper-sc-1n33bhd-0 cHAvbZ table-responsive">
                                <table className=" MonthlyPerformance__Table-sc-1n33bhd-2 bDbyAW">
                                  <tbody className="table MonthlyPerformance__Body-sc-1n33bhd-3 eLhmcV">
                                    <tr>
                                      <th colspan="99" className="MonthlyPerformance__Title-sc-1n33bhd-1 ekfIgT">
                                        Monthly Performance – Class C GBP</th>
                                    </tr>
                                    <tr color="#d8e2e8" className="MonthlyPerformance__Row-sc-1n33bhd-4 elqUjA">

                                      {monthsCArrayState.map(renderMonthNames)}

                                    </tr>


                                  </tbody>
                                </table>

                                <table className="table MonthlyPerformance__Table-sc-1n33bhd-2 bDbyAW table-striped">
                                  <tbody className="table MonthlyPerformance__Body-sc-1n33bhd-3 eLhmcV">

                                    {/* <tr className="MonthlyPerformance__Row-sc-1n33bhd-4 oKXFa"> */}

                                    {monthlyPerformanceC2DArrayState.map(render12MonthsData)}

                                    {/* </tr> */}
                                  </tbody>
                                </table>
                              </div>
                            </div>


                            <div className="col-md-12" >

                              <div className="MonthlyPerformance__Wrapper-sc-1n33bhd-0 cHAvbZ table-responsive">
                                <table className=" MonthlyPerformance__Table-sc-1n33bhd-2 bDbyAW">
                                  <tbody className="table MonthlyPerformance__Body-sc-1n33bhd-3 eLhmcV">
                                    <tr>
                                      <th colspan="99" className="MonthlyPerformance__Title-sc-1n33bhd-1 ekfIgT">
                                        Monthly Performance – Class B EUR</th>
                                    </tr>
                                    <tr color="#d8e2e8" className="MonthlyPerformance__Row-sc-1n33bhd-4 elqUjA">

                                      {monthsDArrayState.map(renderMonthNames)}

                                    </tr>


                                  </tbody>
                                </table>

                                <table className="table MonthlyPerformance__Table-sc-1n33bhd-2 bDbyAW table-striped">
                                  <tbody className="MonthlyPerformance__Body-sc-1n33bhd-3 eLhmcV">

                                    {/* <tr className="MonthlyPerformance__Row-sc-1n33bhd-4 oKXFa"> */}

                                    {monthlyPerformanceD2DArrayState.map(render12MonthsData)}

                                    {/* </tr> */}
                                  </tbody>
                                </table>
                              </div>
                            </div>

                            {/* </div> */}
                          </div>
                          <div className="DailyPricing__SourceWrapper-sc-62f3gi-4 hfRiYK">
                            <p className="mt-2 i">Monthly data as at: {PRTUDate}.
                              All information also available to download <a href={config.apiPath + "/sitepdfs/epic_global_equity_fund.pdf"} target="_blank" download>here </a>
                              <br /></p>
                          </div>
                        </div>

                      </div>


                    </div>
                  </div>
                  <div className="tab-pane fade" id="two" role="tabpanel">
                    <div className="row">
                      <div className="col-sm-12">
                        <div role="tabpanel" aria-hidden="false" className="fade tab-pane active show">
                          <div className="mb-2 row">
                            <div className="col-md-12" dangerouslySetInnerHTML={{ __html: productsCommentary }}>
                              {/* {productsCommentary} */}
                              {/* {bot3contriarray.map(renderbot3contri)} */}


                            </div>
                          </div>
                          <div className="DailyPricing__SourceWrapper-sc-62f3gi-4 hfRiYK">
                            <p className="mt-2 i">Monthly data as at: {PRTUDate}.
                              All information also available to download <a href={config.apiPath + "/sitepdfs/epic_global_equity_fund.pdf"} target="_blank" download>here </a>
                              <br /></p>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                  <div className="tab-pane fade" id="three" role="tabpanel">
                    <div className="row">
                      <div className="col-sm-12">
                        <div role="tabpanel" aria-hidden="false" className="fade tab-pane active show">
                          <div className="mb-2 row">
                            <div className="col table-responsive" >
                              <table className="FundInformation__Table-sc-18irt95-0 cRUpgb">
                                <tbody className=" FundInformation__Body-sc-18irt95-1 hNmQXY">
                                  <tr className="FundInformation__Row-sc-18irt95-2 kzFInj">
                                    <th>Fund Information</th>
                                  </tr>
                                  {Fundinfoarray.map(renderFundinfo)}
                                  {CMSFundinfoarray.map(renderFundinfo)}

                                  {/* <tr className="FundInformation__Row-sc-18irt95-2 fweCQL">
                                  <td className="align-left">Fund Launch Date</td>   
                                  <td className="align-right">20 September 2012</td>
                                </tr>
                                <tr className="FundInformation__Row-sc-18irt95-2 fweCQL">
                                  <td className="align-left">Sector</td>   
                                  <td className="align-right">FE – Equity International</td>
                                </tr>
                                <tr className="FundInformation__Row-sc-18irt95-2 fweCQL">
                                  <td className="align-left">Pricing Frequency</td>   
                                  <td className="align-right">Daily</td>
                                </tr>
                                <tr className="FundInformation__Row-sc-18irt95-2 fweCQL">
                                  <td className="align-left">Domicile</td>   
                                  <td className="align-right">Ireland</td>
                                </tr>
                                <tr className="FundInformation__Row-sc-18irt95-2 fweCQL">
                                  <td className="align-left">Preliminary Charge</td>   
                                  <td className="align-right">Up To 5%</td>
                                </tr>
                                <tr className="FundInformation__Row-sc-18irt95-2 fweCQL">
                                  <td className="align-left">Exit Charge</td>   
                                  <td className="align-right">None</td>
                                </tr> */}

                                  {/* <tr className="FundInformation__Row-sc-18irt95-2 fweCQL">
                                    <td>Fund Launch Date</td>
                                    <td>20 September 2012</td>
                                </tr>
                                <tr className="FundInformation__Row-sc-18irt95-2 fweCQL">
                                    <td>Fund Size</td>
                                    <td>US$42.97m</td>
                                </tr>
                                <tr className="FundInformation__Row-sc-18irt95-2 fweCQL">
                                    <td>1 Day VaR (99%, 3 Year)</td>
                                    <td>1.77%</td>
                                </tr>
                                <tr className="FundInformation__Row-sc-18irt95-2 fweCQL">
                                    <td>Margin to Equity</td>
                                    <td>12.68%</td>
                                </tr>
                                <tr className="FundInformation__Row-sc-18irt95-2 fweCQL">
                                    <td>Gross Notional Exposure</td>
                                    <td>435.85%</td>
                                </tr>
                                <tr className="FundInformation__Row-sc-18irt95-2 fweCQL">
                                    <td>Pricing Frequency</td>
                                    <td>Daily</td>
                                </tr>
                                <tr className="FundInformation__Row-sc-18irt95-2 fweCQL">
                                    <td>Domicile</td>
                                    <td>Ireland</td>
                                </tr>
                                <tr className="FundInformation__Row-sc-18irt95-2 fweCQL">
                                    <td>Exit Charge</td>
                                    <td>None</td>
                                </tr> */}
                                </tbody>
                              </table>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col table-responsive" >
                              <table className="table  Shares__Table-sc-1brks4f-0 hBbtmd wealth-table">
                                <tbody className="Shares__Body-sc-1brks4f-1 hbWYKC">
                                  {/* <tr className="Shares__Row-sc-1brks4f-2 hzpAKA">
                                

                                {ShareClassarray.map(renderShareClassNames)}

                                    <th className="align-left">Share Class</th>
                                    <th className="align-right">A USD</th>
                                    <th className="align-right">A GBP</th>
                                    <th className="align-right">A EUR</th>
                                    <th className="align-right">B USD</th>
                                    <th className="align-right">B GBP</th>
                                    <th className="align-right">B EUR</th>

                                </tr> */}
                                  <tr className="Shares__Row-sc-1brks4f-2 hzpAKA">
                                    {/* <th className="align-left">Share Class</th>
                                <th className="align-right">A GBP</th>
                                <th className="align-right">B GBP</th>
                                <th className="align-right">B EUR</th>
                                <th className="align-right">C GBP</th> */}
                                    {ShareClassarray.map(renderShareClassNames)}
                                  </tr>
                                  {/* {ShareClassarray.map(renderShareClassNames)} */}

                                  {/* <tr className="Shares__Row-sc-1brks4f-2 eoQrEv"> */}
                                  <tr className="Shares__Row-sc-1brks4f-2 eoQrEv">
                                    {ShareClassarray.map(renderShareClassValue)}
                                    {/* <tr className="Shares__Row-sc-1brks4f-2 eoQrEv"><td className="align-left">Minimum Initial Investment</td><td className="align-right">$100,000 </td><td className="align-right">$100,000 </td><td className="align-right">$100,000 </td><td className="align-right">$100</td><td className="align-right">$100</td><td className="align-right">$100</td></tr> */}
                                  </tr>
                                  {CMSshareinfoarray.map(renderCMSshareinfo)}


                                  {/* <tr className="Shares__Row-sc-1brks4f-2 eoQrEv">
                                    <td className="align-left">Minimum Additional Investment</td>
                                    <td className="align-right">$10,000	</td>
                                    <td className="align-right">$10,000	</td>
                                    <td className="align-right">$10,000	</td>
                                    <td className="align-right">$100</td>
                                    <td className="align-right">$100</td>
                                    <td className="align-right">$100</td>
                                </tr>
                                <tr className="Shares__Row-sc-1brks4f-2 eoQrEv">
                                    <td className="align-left">Ongoing Charge (as at 31 December 2020)</td>
                                    <td className="align-right">1.56%</td>
                                    <td className="align-right">1.56%</td>
                                    <td className="align-right">1.55%</td>
                                    <td className="align-right">1.81%</td>
                                    <td className="align-right">1.80%</td>
                                    <td className="align-right">1.81%</td>
                                 </tr>
                                <tr className="Shares__Row-sc-1brks4f-2 eoQrEv">
                                    <td className="align-left">ISIN</td>
                                    <td className="align-right">IE00B86V3N61</td>
                                    <td className="align-right">IE00B8NCXV05</td>
                                    <td className="align-right">IE00B86JXG34</td>
                                    <td className="align-right">IE00B8L77L59</td>
                                    <td className="align-right">IE00B86KNN34</td>
                                    <td className="align-right">IE00B7S9LZ93</td>
                                </tr>
                                <tr className="Shares__Row-sc-1brks4f-2 eoQrEv">
                                    <td className="align-left">Bloomberg Ticker</td>
                                    <td className="align-right">EEADTAU ID</td>
                                    <td className="align-right">EEADTAS ID</td>
                                    <td className="align-right">GARFTAE ID</td>
                                    <td className="align-right">EEADTBU ID</td>
                                    <td className="align-right">EEADTBS ID</td>
                                    <td className="align-right">GARFTBE ID</td>
                                </tr>
                                <tr className="Shares__Row-sc-1brks4f-2 eoQrEv">
                                    <td className="align-left">Citi</td>
                                    <td className="align-right">MD8G</td>
                                    <td className="align-right">I2VK</td>
                                    <td className="align-right">Q6OF</td>
                                    <td className="align-right">I2VL</td>
                                    <td className="align-right">MD8J</td>
                                    <td className="align-right">NTGR</td>
                                </tr>
                                <tr className="Shares__Row-sc-1brks4f-2 eoQrEv">
                                    <td className="align-left">MEXID</td>
                                    <td className="align-right">-</td>
                                    <td className="align-right">GAWXA</td>
                                    <td className="align-right">-</td>
                                    <td className="align-right">-</td>
                                    <td className="align-right">GACMA</td>
                                    <td className="align-right">GAYZA</td>
                                </tr>
                                <tr className="Shares__Row-sc-1brks4f-2 eoQrEv">
                                    <td className="align-left">Open for new investment</td>
                                    <td className="align-right">Yes</td>
                                    <td className="align-right">Yes</td>
                                    <td className="align-right">Yes</td>
                                    <td className="align-right">Yes</td>
                                    <td className="align-right">Yes</td>
                                    <td className="align-right">Yes</td>
                                </tr> */}

                                  {/* <td>NAV per Share</td>
                                    <td align="center" colspan="1">$995.86</td>
                                    <td align="center" colspan="1">£964.27</td>
                                    <td align="center" colspan="1">€820.02</td>
                                    <td align="center" colspan="1">$1,063.31</td>
                                    <td align="center" colspan="1">£795.17</td>
                                    <td align="center" colspan="1">€773.23</td> */}
                                  {/* </tr> */}
                                  {/* <tr className="Shares__Row-sc-1brks4f-2 eoQrEv">
                                    <td>Minimum Initial Investment</td>
                                    <td align="center" colspan="1">$100,000</td>
                                    <td align="center" colspan="1">£100,000</td>
                                    <td align="center" colspan="1">€100,000</td>
                                    <td align="center" colspan="1">$100</td>
                                    <td align="center" colspan="1">£100</td>
                                    <td align="center" colspan="1">€100</td>
                                </tr>
                                <tr className="Shares__Row-sc-1brks4f-2 eoQrEv">
                                    <td>Minimum Additional Investment</td>
                                    <td align="center" colspan="1">$10,000</td>
                                    <td align="center" colspan="1">£10,000</td>
                                    <td align="center" colspan="1">€10,000</td>
                                    <td align="center" colspan="1">$100</td>
                                    <td align="center" colspan="1">£100</td>
                                    <td align="center" colspan="1">€100</td>
                                </tr>
                                <tr className="Shares__Row-sc-1brks4f-2 eoQrEv">
                                    <td>Ongoing Charge (as at 31 December 2020)</td>
                                    <td align="center" colspan="1">1.56%</td>
                                    <td align="center" colspan="1">1.56%</td>
                                    <td align="center" colspan="1">1.55%</td>
                                    <td align="center" colspan="1">1.81%</td>
                                    <td align="center" colspan="1">1.80%</td>
                                    <td align="center" colspan="1">1.81%</td>
                                </tr>
                                <tr className="Shares__Row-sc-1brks4f-2 eoQrEv">
                                    <td>Performance Fee</td>
                                    <td align="center" colspan="99">20%, High water mark</td>
                                </tr>
                                <tr className="Shares__Row-sc-1brks4f-2 eoQrEv">
                                    <td>UK Reporting Fund Status</td>
                                    <td align="center" colspan="99">Yes (All share classes)</td>
                                </tr>
                                <tr className="Shares__Row-sc-1brks4f-2 eoQrEv">
                                    <td>ISIN</td>
                                    <td align="center" colspan="1">IE00B86V3N61</td>
                                    <td align="center" colspan="1">IE00B8NCXV05</td>
                                    <td align="center" colspan="1">IE00B86JXG34</td>
                                    <td align="center" colspan="1">IE00B8L77L59</td>
                                    <td align="center" colspan="1">IE00B86KNN34</td>
                                    <td align="center" colspan="1">IE00B7S9LZ93</td>
                                </tr>
                                <tr className="Shares__Row-sc-1brks4f-2 eoQrEv">
                                    <td>Bloomberg Ticker</td>
                                    <td align="center" colspan="1">EEADTAU ID</td>
                                    <td align="center" colspan="1">EEADTAS ID</td>
                                    <td align="center" colspan="1">GARFTAE ID</td>
                                    <td align="center" colspan="1">EEADTBU ID</td>
                                    <td align="center" colspan="1">EEADTBS ID</td>
                                    <td align="center" colspan="1">GARFTBE ID</td>
                                </tr>
                                <tr className="Shares__Row-sc-1brks4f-2 eoQrEv">
                                    <td>Citi</td>
                                    <td align="center" colspan="1">MD8G</td>
                                    <td align="center" colspan="1">I2VK</td>
                                    <td align="center" colspan="1">Q6OF</td>
                                    <td align="center" colspan="1">I2VL</td>
                                    <td align="center" colspan="1">MD8J</td>
                                    <td align="center" colspan="1">NTGR</td>
                                </tr>
                                <tr className="Shares__Row-sc-1brks4f-2 eoQrEv">
                                    <td>MEXID</td>
                                    <td align="center" colspan="1">-</td>
                                    <td align="center" colspan="1">GAWXA</td>
                                    <td align="center" colspan="1">-</td>
                                    <td align="center" colspan="1">-</td>
                                    <td align="center" colspan="1">GACMA</td>
                                    <td align="center" colspan="1">GAYZA</td>
                                </tr>
                                <tr className="Shares__Row-sc-1brks4f-2 eoQrEv">
                                    <td>Open for new investment</td>
                                    <td align="center" colspan="1">Yes</td>
                                    <td align="center" colspan="1">Yes</td>
                                    <td align="center" colspan="1">Yes</td>
                                    <td align="center" colspan="1">Yes</td>
                                    <td align="center" colspan="1">Yes</td>
                                    <td align="center" colspan="1">Yes</td>
                                </tr> */}
                                </tbody>
                              </table>
                            </div>
                          </div>
                          <div className="DailyPricing__SourceWrapper-sc-62f3gi-4 hfRiYK">
                            <p className="mt-2 i">Monthly data as at: {PRTUDate}.
                              All information also available to download <a href={config.apiPath + "/sitepdfs/epic_global_equity_fund.pdf"} target="_blank" download>here </a>
                              <br /></p>
                          </div>
                        </div>

                      </div>

                    </div>
                  </div>
                  <div className="tab-pane fade" id="four" role="tabpanel">
                    <div className="row">
                      <div className="col-sm-12">

                        <div className="row ">


                          {KeyInveInfoState.length > 0 ? <div className="col-md-12"><h3><b>Key Investor Information</b></h3><br /></div> : ""}
                          {KeyInveInfoState.length > 0 ? KeyInveInfoState.map(renderLiteratureData) : ""}

                          <div className="col-sm-12">

                            <p className="pdf_download">
                              <h4>Fact Sheet</h4>

                              <a href={config.apiPath + "/sitepdfs/epic_global_equity_fund.pdf"} target="_blank" download>Global Equity Fund PDF
                                <br />
                              </a>
                            </p>
                          </div>

                          {LiteratureDataState.length > 0 ? <div className="col-md-12"><h3><b>Other Information</b></h3><br /></div> : ""}
                          {LiteratureDataState.length > 0 ? LiteratureDataState.map(renderLiteratureData) : ""}

                          {PressCoverageState.length > 0 ? <div className="col-md-12"><h3><b>Recent Updates
                          </b></h3><br /></div> : ""}
                          {PressCoverageState.length > 0 ? PressCoverageState.map(renderLiteratureData) : ""}


                          {ApplicationsState.length > 0 ? <div className="col-md-12"><h3><b>Applications</b></h3><br /></div> : ""}
                          {ApplicationsState.length > 0 ? ApplicationsState.map(renderLiteratureData) : ""}

                          {ReportsState.length > 0 ? <div className="col-md-12"><h3><b>Reports</b></h3><br /></div> : ""}
                          {ReportsState.length > 0 ? ReportsState.map(renderLiteratureData) : ""}

                          {offerDocumentState.length > 0 ? <div className="col-md-12"><h3><b>Offering Documents</b></h3><br /></div> : ""}
                          {offerDocumentState.length > 0 ? offerDocumentState.map(renderLiteratureData) : ""}

                          {/* <div className="col-sm-6">
					  <p className="pdf_download"><a href="files/2021-ESO-AGM-Proxy_32699907_3_0.pdf">2021 AGM Proxy Form<br/><span className="date">21 May 2021</span></a></p>
				  </div> */}
                        </div>
                        {/* <div className="row">
				  <div className="col-sm-6">
					  <p className="pdf_download"><a href="files/2021-05-20-ESO-AGM-Notice-V3-326976254-clean.pdf">2021 Notice of AGM
                      <br/><span className="date">20 May 2021</span></a></p>
				  </div>
				  <div className="col-sm-6">
					  <p className="pdf_download"><a href="files/2021-ESO-AGM-Proxy_32699907_3_0.pdf">2021 AGM Proxy Form<br/><span className="date">21 May 2021</span></a></p>
				  </div>
          </div>
          <div className="row">
				  <div className="col-sm-6">
					  <p className="pdf_download"><a href="files/2021-05-20-ESO-AGM-Notice-V3-326976254-clean.pdf">2021 Notice of AGM
                      <br/><span className="date">20 May 2021</span></a></p>
				  </div>
				  <div className="col-sm-6">
					  <p className="pdf_download"><a href="files/2021-ESO-AGM-Proxy_32699907_3_0.pdf">2021 AGM Proxy Form<br/><span className="date">21 May 2021</span></a></p>
				  </div>
          </div>
          <div className="row">
				  <div className="col-sm-6">
					  <p className="pdf_download"><a href="files/2021-05-20-ESO-AGM-Notice-V3-326976254-clean.pdf">2021 Notice of AGM
                      <br/><span className="date">20 May 2021</span></a></p>
				  </div>
				  <div className="col-sm-6">
					  <p className="pdf_download"><a href="files/2021-ESO-AGM-Proxy_32699907_3_0.pdf">2021 AGM Proxy Form<br/><span className="date">21 May 2021</span></a></p>
				  </div>
          </div>
          <div className="row">
				  <div className="col-sm-6">
					  <p className="pdf_download"><a href="files/2021-05-20-ESO-AGM-Notice-V3-326976254-clean.pdf">2021 Notice of AGM
                      <br/><span className="date">20 May 2021</span></a></p>
				  </div>
				  <div className="col-sm-6">
					  <p className="pdf_download"><a href="files/2021-ESO-AGM-Proxy_32699907_3_0.pdf">2021 AGM Proxy Form<br/><span className="date">21 May 2021</span></a></p>
				  </div>
          </div> */}

                      </div>

                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </section>
        : <div className="center"><ReactBootstrap.Spinner animation="border" /></div>
      }
    </Fragment>
  );
}

export default EpicglobalEquity;

